<template>
  <div class="current-rides container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>

    <div class="row page-titles">
        <div class="col-md-5 align-self-center">
            <h3 class="text-themecolor">{{ title }}</h3>
        </div>
        <div class="col-md-7 align-self-center">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                <li class="breadcrumb-item active">{{ title }}</li>
            </ol>
        </div>
    </div>


    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item"> <a class="nav-link active"  @click="clearAllOption(); getReadyToSubmitList(); showColumnFilters = true;" data-toggle="tab" href="#ready-to-submit-tab" role="tab"><span class="hidden-sm-up"><i class="ti-home"></i></span> <span class="hidden-xs-down">Ready to submit ({{ getClaimsCount(null, null, 'ready_to_submit') }})</span></a> </li>
                <li class="nav-item"> <a class="nav-link" @click="getIssueList(); showColumnFilters = true;" data-toggle="tab" href="#issue-trips-tab" role="tab"><span class="hidden-sm-up"><i class="ti-user"></i></span> <span class="hidden-xs-down">Issue Trips ({{ getClaimsCount(null, null, 'warning') }})</span></a> </li>
                <li class="nav-item"> <a class="nav-link" @click="getRejectionsList(); showColumnFilters = true;" data-toggle="tab" href="#rejected-trips-tab" role="tab"><span class="hidden-sm-up"><i class="ti-email"></i></span> <span class="hidden-xs-down">Rejected Trips ({{ getClaimsCount(null, null, 'rejected') }})</span></a> </li>
                <li class="nav-item"> <a class="nav-link" @click="getDeniedList(); showColumnFilters = true;" data-toggle="tab" href="#denied-trips-tab" role="tab"><span class="hidden-sm-up"><i class="ti-user"></i></span> <span class="hidden-xs-down">Denied Trips ({{ getClaimsCount(null, null, 'denied') }})</span></a> </li>
                <li class="nav-item"> <a class="nav-link" @click="clearAllOption(); getReadyToSubmitManuallyList(); showColumnFilters = true;" data-toggle="tab" href="#ready-to-submit-manually-tab" role="tab"><span class="hidden-sm-up"><i class="ti-user"></i></span> <span class="hidden-xs-down">Ready for Manual Submission Trips ({{ getClaimsCount(null, null, 'ready_to_submit_manually') }})</span></a> </li>
                <li class="nav-item"> <a class="nav-link" @click="getUnclaimableList(); showColumnFilters = true;" data-toggle="tab" href="#unclaimable-trips-tab" role="tab"><span class="hidden-sm-up"><i class="ti-user"></i></span> <span class="hidden-xs-down">Unclaimable Trips ({{ getClaimsCount(null, null, 'unclaimable') }})</span></a> </li>
                <li class="nav-item"> <a class="nav-link" @click="getAllTripsList(); showColumnFilters = true;" data-toggle="tab" href="#all-trips-tab" role="tab"><span class="hidden-sm-up"><i class="ti-email"></i></span> <span class="hidden-xs-down">All Trips</span></a> </li>
                <li class="nav-item"> <a class="nav-link" @click="clearAllOption(); getPlatformFeeOnlyRides(); showColumnFilters = false;" data-toggle="tab" href="#platform-fee-only-tab" role="tab"><span class="hidden-sm-up"><i class="ti-email"></i></span> <span class="hidden-xs-down">Additional Payments</span></a> </li>
                <li class="nav-item"> <a class="nav-link" @click="clearAllOption(); getNoResponseList(); showColumnFilters = false;" data-toggle="tab" href="#no-response-tab" role="tab"><span class="hidden-sm-up"><i class="ti-email"></i></span> <span class="hidden-xs-down">Old Dropoffs</span></a> </li>
                <li class="nav-item"> <a class="nav-link" @click="getSubmissions();  showColumnFilters = false;" data-toggle="tab" href="#submissions-tab" role="tab"><span class="hidden-sm-up"><i class="ti-email"></i></span> <span class="hidden-xs-down">Submissions</span></a> </li>


                <li class="column-settings dropdown mega-dropdown" v-if="showColumnFilters">
                  <button type="button" class="btn" data-toggle="dropdown" data-display="static" aria-haspopup="true" aria-expanded="false">
                    <i class="mdi mdi-settings"></i>Customize Columns
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <ul>
                      <li>
                        Select visible columns:
                      </li>
                      <li v-for="(item, index) in data.resultColumns">
                        <input type="checkbox" :id="'md_checkbox_' + index" class="column-selector-checkbox chk-col-grey" :data-column-class-name="'hide-col-' + index" checked="">
                        <label :for="'md_checkbox_' + index">{{item.name}}</label>
                      </li>
                      <!-- <li>
                        <button type="button" class="btn btn-block btn-lg btn-warning">Apply</button>
                      </li> -->
                    </ul>

                  </div>
                  </li>
            </ul>
            <div class="result tab-content tabcontent-border">
              <!-- READY TO SUBMIT TAB -->
              <div class="tab-pane active table-responsive" id="ready-to-submit-tab">
                <div class="tab-options">
                  <div>
                    <div class="table-header-filter" style="width: 200px">
                      <label>Page Size: </label>
                      <select v-model="perPage" class="form-control table-select" @change="getReadyToSubmitList(1)">
                        <option v-for="size in page_sizes" v-bind:key="size" v-bind:value="size">
                          {{size}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 255px">
                      <label>Provider: </label>
                      <select type="text" placeholder="Market" v-model="selected_provider"
                              class="form-control ddown" id="rider-filter" v-on:change="getReadyToSubmitList(1)">
                        <option v-for="item in data.markets" v-bind:key="item.id_market"  v-bind:value="item.id_market">
                          {{item.name}} ({{ getClaimsCount(item.name, null, 'ready_to_submit') }})
                        </option>
                        <option value="deadhead">Deadhead ({{ getClaimsCount('Deadhead', null, 'ready_to_submit') }})</option>

                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 370px">
                      <label>Activity Period: </label>
                      <select @change="getReadyToSubmitList()" v-model="selected_activity_period" class="form-control ddown">
                        <option value="all">All</option>
                        <option v-for="week in data.weeks" v-bind:value="week.week" v-bind:key="week.week">
                          {{ moment(week.monday).format('YYYY-MM-DD') +  ' - ' + moment(week.sunday).format('YYYY-MM-DD') }} ({{ getClaimsCount(null, moment(week.monday).format('YYYY-MM-DD'), 'ready_to_submit') }})
                        </option>
                      </select>
                    </div>
                  </div>
                  <div style="position: absolute; right: 0; padding: 0px 20px; z-index:100;">
                    <div class="col-12" style="display:inline;">
                      <a style="color: white;" class="btn submit-button" @click="showConfirmSubmissionModal=true;">Submit to Claims</a>
                    </div>
                    <!-- <div class="col-12" style="display:inline;">
                      <a style="color: white; " class="btn submit-button" @click="generate_manual_submission(data.readyToSubmitList);">Generate Manual Submission</a>
                    </div> -->
                  </div>
                </div>
                <div style="overflow-x:auto; min-height:300px">
                  <table class="table table-hover table-sm editable-table ">
                    <thead>
                      <tr>
                        <th class="result-label" style="min-width: 100px;">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Action
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a class="dropdown-item" @click="checkAll(data.readyToSubmitList)" href="#">Select All</a>
                              <a class="dropdown-item" @click="uncheckAll()" href="#">Select None</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(3, getReadyToSubmitList)" href="#">Move Selection to Issue List</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(4, getReadyToSubmitList)" href="#">Move Selection to Submitted</a>
                              <a class="dropdown-item" @click="validateClaims(false, getReadyToSubmitList)" href="#">Validate SET Status of selection</a>
                            </div>
                          </div>
                        </th>
                        <th class="result-label" :class="'datatable-col-' + index" v-for="(column, index) in data.resultColumns" >
                          <div class="nowrap" style="" @click="sort('ready_' + column.sort_key, getReadyToSubmitList)" v-if="column.sort_key">
                            {{column.name}}
                            <div class="arrow-down" :ref="'ready_' + column.sort_key" :name="column.sort_key" :value="1" style="visibility: hidden; margin-left: 5px;"></div>
                          </div>
                          <div class="nowrap" style=""  v-if="!column.sort_key">
                            {{column.name}}
                            <div class="arrow-down" style="visibility: hidden; margin-left: 5px;"></div>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody class="col-12">
                    <tr v-for="ride in data.readyToSubmitList">
                     <td class="result-item text-center" width="80px">
                        <input type='checkbox' v-bind:value='ride.id_transaction' v-model='data.bulkSelection' v-bind:id="'bulk_select_' + ride.id_transaction">
                        <label class="search-label" v-bind:for="'bulk_select_' + ride.id_transaction" style="margin-bottom: 0; padding: 0px 0px 0px 26px; height: 15px;"></label>
                      </td>
                      <td class="result-item nowrap" :class="['datatable-col-' + index, (column.api_field_name && ride.claims_error && ride.claims_error[column.api_field_name]) ? 'error-cell' : '']" v-for="(column, index) in data.resultColumns" >

                        <router-link v-if="ride.id_ride && ride.id_ride.id_ride && column.routerSelector && column.routerSelector(ride)" :to="column.routerSelector(ride)">
                          {{ (ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''}}
                          <br>
                        </router-link>
                        <div v-else-if="column.name == 'Action'">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Action
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 4, getReadyToSubmitList)" href="#">Ride submitted</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 3, getReadyToSubmitList)" href="#">Move to issue list</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 7, getReadyToSubmitList)" href="#">Rejected FTP</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 1, getReadyToSubmitList)" href="#">Ride not provided</a>
                              <a class="dropdown-item" @click="reverseRide(ride.id_ride, ride.id_transaction, getReadyToSubmitList)" href="#">Reverse Ride Payment</a>

                            </div>
                          </div>
                        </div>

                        <span v-else v-html="(ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''"></span>

                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                  <div style="margin: 1rem 1rem; float: left;">
                    <!-- <span v-if="totalRows > 0">Showing {{ data.readyToSubmitList.length }} entries</span> -->
                    <span v-if="readyToSubmitRows > 0">Showing {{ perPage * (currentReadyToSubmitPage-1) + 1 }} to {{ perPage * currentReadyToSubmitPage > readyToSubmitRows ? readyToSubmitRows : perPage * currentReadyToSubmitPage }} of {{ readyToSubmitRows }} entries</span>
                    <span v-else>Showing 0 entries</span>
                  </div>
                  <div style="margin: 0 1rem; float: right;">
                    <b-pagination style="margin: .5rem 0;" align="center" :total-rows=readyToSubmitRows v-model="currentReadyToSubmitPage" :per-page=perPage :limit=perPage @change="changeReadyToSubmitPage">
                    </b-pagination>
                  </div>


                </div>
              </div>
              <!-- READY TO SUBMIT MANUALLY -->
              <div class="tab-pane table-responsive" id="ready-to-submit-manually-tab">
                <div class="tab-options">
                  <div>
                    <div class="table-header-filter" style="width: 200px">
                      <label>Page Size: </label>
                      <select v-model="perPage" class="form-control table-select" @change="getReadyToSubmitManuallyList(1)">
                        <option v-for="size in page_sizes" v-bind:key="size" v-bind:value="size">
                          {{size}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 255px">
                      <label>Provider: </label>
                      <select type="text" placeholder="Market" v-model="selected_provider"
                              class="form-control ddown" id="rider-filter" v-on:change="getReadyToSubmitManuallyList(1)">
                        <option v-for="item in data.markets" v-bind:key="item.id_market"  v-bind:value="item.id_market">
                          {{item.name}} ({{ getClaimsCount(item.name, null, 'ready_to_submit_manually') }})
                        </option>
                        <option value="deadhead">Deadhead ({{ getClaimsCount('Deadhead', null, 'ready_to_submit_manually') }})</option>

                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 370px">
                      <label>Activity Period: </label>
                      <select @change="getReadyToSubmitManuallyList()" v-model="selected_activity_period" class="form-control ddown">
                        <option value="all">All</option>
                        <option v-for="week in data.weeks" v-bind:value="week.week" v-bind:key="week.week">
                          {{ moment(week.monday).format('YYYY-MM-DD') +  ' - ' + moment(week.sunday).format('YYYY-MM-DD') }} ({{ getClaimsCount(null, moment(week.monday).format('YYYY-MM-DD'), 'ready_to_submit_manually') }})
                        </option>
                      </select>
                    </div>
                  </div>
                  <div style="position: absolute; right: 0; padding: 0px 20px; z-index:100;">
                    <div class="col-12" style="display:inline;">
                      <a style="color: white; " class="btn submit-button" @click="showConfirmManualSubmissionModal = true; submissionManualList = data.readyToSubmitManuallyList;">Generate Manual Submission</a>
                    </div>
                  </div>

                </div>
                  <!-- <div class="col-12" style="display:inline;">
                    <a style="color: white;" class="btn submit-button" @click="showConfirmSubmissionModal=true;">Submit to Claims</a>
                  </div> -->
                <div style="overflow-x:auto; min-height: 300px;">
                  <table class="table table-hover table-sm editable-table ">
                    <thead>
                      <tr>
                        <th class="result-label" style="min-width: 100px;">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Action
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a class="dropdown-item" @click="checkAll(data.readyToSubmitManuallyList)" href="#">Select All</a>
                              <a class="dropdown-item" @click="uncheckAll()" href="#">Select None</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(3, getReadyToSubmitManuallyList)" href="#">Move Selection to Issue List</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(8, getReadyToSubmitManuallyList)" href="#">Move Selection to Submitted Manually</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(6, getReadyToSubmitManuallyList)" href="#">Move Selection to Denied</a>
                              <a class="dropdown-item" @click="validateClaims(false, getReadyToSubmitManuallyList)" href="#">Validate SET Status of selection</a>
                            </div>
                          </div>
                        </th>
                        <th class="result-label" :class="'datatable-col-' + index" v-for="(column, index) in data.resultColumns" >
                          <div class="nowrap" style="" @click="sort('manual_' + column.sort_key, getReadyToSubmitManuallyList)" v-if="column.sort_key">
                            {{column.name}}
                            <div class="arrow-down" :ref="'manual_' + column.sort_key" :name="column.sort_key" :value="1" style="visibility: hidden; margin-left: 5px;"></div>
                          </div>
                          <div class="nowrap" style=""  v-if="!column.sort_key">
                            {{column.name}}
                            <div class="arrow-down" style="visibility: hidden; margin-left: 5px;"></div>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody class="col-12">
                    <tr v-for="ride in data.readyToSubmitManuallyList">
                     <td class="result-item text-center" width="80px">
                        <input type='checkbox' v-bind:value='ride.id_transaction' v-model='data.bulkSelection' v-bind:id="'bulk_select_' + ride.id_transaction">
                        <label class="search-label" v-bind:for="'bulk_select_' + ride.id_transaction" style="margin-bottom: 0; padding: 0px 0px 0px 26px; height: 15px;"></label>
                      </td>
                      <td class="result-item nowrap" :class="['datatable-col-' + index, (column.api_field_name && ride.claims_error && ride.claims_error[column.api_field_name]) ? 'error-cell' : '']" v-for="(column, index) in data.resultColumns" >

                        <router-link v-if="ride.id_ride && ride.id_ride.id_ride && column.routerSelector && column.routerSelector(ride)" :to="column.routerSelector(ride)">
                          {{ (ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''}}
                          <br>
                        </router-link>
                        <div v-else-if="column.name == 'Action'">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Action
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 8, getReadyToSubmitManuallyList)" href="#">Ride submitted manually</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 3, getReadyToSubmitManuallyList)" href="#">Move to issue list</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 7, getReadyToSubmitManuallyList)" href="#">Rejected FTP</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 1, getReadyToSubmitManuallyList)" href="#">Ride not provided</a>
                              <a class="dropdown-item" @click="reverseRide(ride.id_ride, ride.id_transaction, getReadyToSubmitManuallyList)" href="#">Reverse Ride Payment</a>

                            </div>
                          </div>
                        </div>

                        <span v-else v-html="(ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''"></span>

                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                  <div style="margin: 1rem 1rem; float: left;">
                    <!-- <span v-if="totalRows > 0">Showing {{ data.readyToSubmitList.length }} entries</span> -->
                    <span v-if="readyToSubmitManuallyRows > 0">Showing {{ perPage * (currentReadyToSubmitManuallyPage-1) + 1 }} to {{ perPage * currentReadyToSubmitManuallyPage > readyToSubmitManuallyRows ? readyToSubmitManuallyRows : perPage * currentReadyToSubmitManuallyPage }} of {{ readyToSubmitManuallyRows }} entries</span>
                    <span v-else>Showing 0 entries</span>
                  </div>
                  <div style="margin: 0 1rem; float: right;">
                    <b-pagination style="margin: .5rem 0;" align="center" :total-rows=readyToSubmitManuallyRows v-model="currentReadyToSubmitManuallyPage" :per-page=perPage :limit=perPage @change="changeReadyToSubmitPage">
                    </b-pagination>
                  </div>


                </div>
              </div>
              <!-- ISSUES TAB -->
              <div class="tab-pane table-responsive" id="issue-trips-tab">
                <div class="tab-options">
                 <div>
                    <div class="table-header-filter" style="width: 200px">
                      <label>Page Size: </label>
                      <select v-model="perPage" class="form-control table-select" @change="getIssueList(1)">
                        <option v-for="size in page_sizes" v-bind:key="size" v-bind:value="size">
                          {{size}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 255px">
                      <label>Provider: </label>
                      <select type="text" placeholder="Market" v-model="selected_provider"
                              class="form-control ddown" id="rider-filter" v-on:change="getIssueList(1)">
                        <option value="all">All ({{ getClaimsCount(null, null, 'warning') }})</option>
                        <option v-for="item in data.markets" v-bind:key="item.id_market"  v-bind:value="item.id_market">
                          {{item.name}} ({{ getClaimsCount(item.name, null, 'warning') }})
                        </option>
                        <option value="deadhead">Deadhead ({{ getClaimsCount('Deadhead', null, 'warning') }})</option>

                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 370px">
                      <label>Activity Period: </label>
                      <select @change="getIssueList()" v-model="selected_activity_period" class="form-control ddown">
                        <option value="all">All</option>
                        <option v-for="week in data.weeks" v-bind:value="week.week" v-bind:key="week.week">
                          {{ moment(week.monday).format('YYYY-MM-DD') +  ' - ' + moment(week.sunday).format('YYYY-MM-DD') }} ({{ getClaimsCount(null, moment(week.monday).format('YYYY-MM-DD'), 'warning') }})
                        </option>
                      </select>
                    </div>
                  </div>


                </div>
                <!-- <div style="position: absolute; right: 0; padding: 25px 20px; z-index:100;">
                  <div class="col-12" style="display:inline;">
                    <a style="color: white;" class="btn submit-button" @click="showConfirmSubmissionModal=true;">Submit to Claims</a>
                  </div>
                  <div class="col-12" style="display:inline;">
                    <a style="color: white; " class="btn submit-button" @click="generate_manual_submission(data.readyToSubmitList);">Generate Manual Submission</a>
                  </div>

                </div>  -->
                <div style="overflow-x:auto;min-height: 500px;">
                  <form v-on:submit.prevent>
                  <table class="table table-hover table-sm editable-table ">
                    <thead>
                      <tr>
                        <th class="result-label" style="min-width: 100px;">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Action
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a class="dropdown-item" @click="checkAll(data.issueList)" href="#">Select All</a>
                              <a class="dropdown-item" @click="uncheckAll()" href="#">Select None</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(1, getIssueList)" href="#">Move Selection to Not provided</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(2, getIssueList)" href="#">Move Selection to Ready to submit</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(4, getIssueList)" href="#">Move Selection to Submitted</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(9, getIssueList)" href="#">Move Selection to Ready to submit Manually</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(8, getIssueList)" href="#">Move Selection to Submitted Manually</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(5, getIssueList)" href="#">Move Selection to Approved</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(10, getIssueList)" href="#">Move Selection to Unclaimable</a>

                              <a class="dropdown-item" @click="validateClaims(false, getIssueList)" href="#">Validate SET Status of selection</a>

                            </div>
                          </div>
                        </th>
                        <th class="result-label" :class="'datatable-col-' + index" v-for="(column, index) in data.resultColumns" >
                          <div class="nowrap" style="" @click="sort('issues_' + column.sort_key, getIssueList)" v-if="column.sort_key">
                            {{column.name}}
                            <div class="arrow-down" :ref="'issues_' + column.sort_key" :name="column.sort_key" :value="1" style="visibility: hidden; margin-left: 5px;"></div>
                          </div>
                          <div class="nowrap" style=""  v-if="!column.sort_key">
                            {{column.name}}
                            <div class="arrow-down" style="visibility: hidden; margin-left: 5px;"></div>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody class="col-12">
                    <tr v-for="ride in data.issueList" v-bind:key="ride.id_transaction">
                      <td class="result-item text-center" width="80px">
                        <input type='checkbox' v-bind:value='ride.id_transaction' v-model='data.bulkSelection' v-bind:id="'bulk_select_' + ride.id_transaction">
                        <label class="search-label" v-bind:for="'bulk_select_' + ride.id_transaction" style="margin-bottom: 0; padding: 0px 0px 0px 26px; height: 15px;"></label>
                      </td>
                      <td class="result-item nowrap" :class="['datatable-col-' + index, (column.api_field_name && ride.claims_error[column.api_field_name]) ? 'error-cell' : '',(column.name && column.name == '_Action') ? 'mytooltip tooltip-effect-3' : '']" v-for="(column, index) in data.resultColumns" v-bind:key="column.name + '_'+ index" >
                        <div v-if="column.api_field_name && ride.claims_error[column.api_field_name] && column.name == '_Action'" class="tooltip-content clearfix">
                          {{ride.claims_error[column.api_field_name]}}
                        </div>

                        <router-link v-if="ride.id_ride && ride.id_ride.id_ride && column.routerSelector && column.routerSelector(ride)" :to="column.routerSelector(ride)">
                          {{ (ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''}}
                          <br>
                        </router-link>
                        <div class="transaction-edit-cell dropdown" v-else-if="column.editable && column.type && ride.id_ride && ride.id_ride.id_ride">
                          <div class="dropdown-toggle" data-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false"  @click="setEnableEditField(ride, index, ride.id_ride[column.api_field_name]);">
                            {{ column.selector(ride) }}
                            <!-- <font-awesome-icon @click="showVehicleModel(ride.id_ride);" icon="edit" style="color: rgb(0, 0, 0); cursor: pointer"/> -->
                          </div>
                          <div class="dropdown-menu">
                            <div class="warning-msg"> {{ride.claims_error[column.api_field_name]}}</div>
                            <div style="display: flex; flex-direction: row; align-items: center; ">
                              <!-- <datetime v-if="column.type=='date'" type="datetime" v-model="edit_field_value" label="Pickup Time" input-class="form-control form-control-sm" placeholder="Pickup Time" ></datetime>
                              <input v-else autofocus v-model = "edit_field_value" class=" form-control" style="width:300px" /> -->

                              <input autofocus v-model = "edit_field_value" class=" form-control" style="width:300px" />

                              <font-awesome-icon class="close-dropdown-link" @click="setEnableEditField(null,null, null)" icon="times" style="float:right; margin:5px; color: rgb(239, 83, 80); cursor: pointer"/>
                              <font-awesome-icon class="close-dropdown-link" @click="updateRide(ride.id_ride)" icon="check" style="float:right; margin:5px; color: rgb(38, 166, 154); cursor: pointer"/>
                            </div>
                            <button v-for="(b, actionIndex) in column.actions" v-bind:key="actionIndex" class="btn btn-secondary close-dropdown-link" style="display:block;" @click="b.action(ride)">{{b.name}}</button>

                          </div>
                        </div>
                        <div v-else-if="column.name == 'Action'">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Action
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 2, getIssueList)" href="#">Ready to submit</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 9, getIssueList)" href="#">Ready to submit manually</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 7, getIssueList)" href="#">Rejected FTP</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 1, getIssueList)" href="#">Ride not provided</a>
                              <a class="dropdown-item" @click="reverseRide(ride.id_ride, ride.id_transaction, getIssueList)" href="#">Reverse Ride Payment</a>

                            </div>
                          </div>
                        </div>
                        <a v-else-if="column.click_action" @click="column.click_action(ride)">{{(ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''}}</a>


                        <span v-else v-html="(ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''"></span>

                      </td>
                    </tr>
                    </tbody>
                  </table>
                  </form>
                </div>

                <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                  <div style="margin: 1rem 1rem; float: left;">
                    <span v-if="totalRows > 0">Showing {{ perPage * (currentPage-1) + 1 }} to {{ perPage * currentPage > totalRows ? totalRows : perPage * currentPage }} of {{ totalRows }} entries</span>
                    <span v-else>Showing 0 entries</span>                  </div>
                  <div style="margin: 0 1rem; float: right;">
                    <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalRows v-model="currentPage" :per-page=perPage :limit=perPage @change="changePage">
                    </b-pagination>
                  </div>
                </div>
              </div>
              <!-- UNCLAIMABLE TAB -->
              <div class="tab-pane table-responsive" id="unclaimable-trips-tab">
                <div class="tab-options">
                  <div>
                    <div class="table-header-filter" style="width: 200px">
                      <label>Page Size: </label>
                      <select v-model="perPage" class="form-control table-select" @change="getUnclaimableList(1)">
                        <option v-for="size in page_sizes" v-bind:key="size" v-bind:value="size">
                          {{size}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 255px">
                      <label>Provider: </label>
                      <select type="text" placeholder="Market" v-model="selected_provider"
                              class="form-control ddown" id="rider-filter" v-on:change="getUnclaimableList(1)">
                        <option value="all">All ({{ getClaimsCount(null, null, 'unclaimable') }})</option>
                        <option v-for="item in data.markets" v-bind:key="item.id_market"  v-bind:value="item.id_market">
                          {{item.name}} ({{ getClaimsCount(item.name, null, 'unclaimable') }})
                        </option>
                        <option value="deadhead">Deadhead ({{ getClaimsCount('Deadhead', null, 'unclaimable') }})</option>

                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 370px">
                      <label>Activity Period: </label>
                      <select @change="getUnclaimableList()" v-model="selected_activity_period" class="form-control ddown">
                        <option value="all">All</option>
                        <option v-for="week in data.weeks" v-bind:value="week.week" v-bind:key="week.week">
                          {{ moment(week.monday).format('YYYY-MM-DD') +  ' - ' + moment(week.sunday).format('YYYY-MM-DD') }} ({{ getClaimsCount(null, moment(week.monday).format('YYYY-MM-DD'), 'unclaimable') }})
                        </option>
                      </select>
                    </div>
                  </div>

                </div>
                <!-- <div style="position: absolute; right: 0; padding: 25px 20px; z-index:100;">
                  <div class="col-12" style="display:inline;">
                    <a style="color: white; " class="btn submit-button" @click="showConfirmManualSubmissionModal = true; submissionManualList = data.deniedList;">Generate Manual Submission</a>
                  </div>

                </div>  -->

                <div style="overflow-x:auto; min-height: 500px;">
                  <table class="table table-hover table-sm editable-table ">
                    <thead>
                      <tr>
                        <th class="result-label" style="min-width: 100px;">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Action
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a class="dropdown-item" @click="checkAll(data.unclaimableList)" href="#">Select All</a>
                              <a class="dropdown-item" @click="uncheckAll()" href="#">Select None</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(2, getUnclaimableList)" href="#">Move Selection to Ready to submit</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(4, getUnclaimableList)" href="#">Move Selection to Submitted</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(9, getUnclaimableList)" href="#">Move Selection to Ready to Submit Manually</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(8, getUnclaimableList)" href="#">Move Selection to Submitted Manually</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(6, getUnclaimableList)" href="#">Move Selection to Denied</a>

                              <a class="dropdown-item" @click="bulkUpdateStatus(1, getUnclaimableList)" href="#">Move Selection to Not provided</a>
                              <a class="dropdown-item" @click="validateClaims(false, getUnclaimableList)" href="#">Validate SET Status of selection</a>

                            </div>
                          </div>
                        </th>
                        <th class="result-label" :class="'datatable-col-' + index" v-for="(column, index) in data.resultColumns" >
                          <div class="nowrap" style="" @click="sort('unclaimable_' + column.sort_key, getUnclaimableList)" v-if="column.sort_key">
                            {{column.name}}
                            <div class="arrow-down" :ref="'unclaimable_' + column.sort_key" :name="column.sort_key" :value="1" style="visibility: hidden; margin-left: 5px;"></div>
                          </div>
                          <div class="nowrap" style=""  v-if="!column.sort_key">
                            {{column.name}}
                            <div class="arrow-down" style="visibility: hidden; margin-left: 5px;"></div>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody class="col-12">
                    <tr v-for="ride in data.unclaimableList" v-bind:key="ride.id_transaction">
                      <td class="result-item text-center" width="80px">
                        <input type='checkbox' v-bind:value='ride.id_transaction' v-model='data.bulkSelection' v-bind:id="'bulk_select_' + ride.id_transaction">
                        <label class="search-label" v-bind:for="'bulk_select_' + ride.id_transaction" style="margin-bottom: 0; padding: 0px 0px 0px 26px; height: 15px;"></label>
                      </td>
                      <td class="result-item nowrap" :class="['datatable-col-' + index, (column.api_field_name && ride.claims_error[column.api_field_name]) ? 'error-cell' : '',(column.name && column.name == '_Action') ? 'mytooltip tooltip-effect-3' : '']" v-for="(column, index) in data.resultColumns" v-bind:key="column.name + '_'+ index" >
                        <div v-if="column.api_field_name && ride.claims_error[column.api_field_name] && column.name == '_Action'" class="tooltip-content clearfix">
                          {{ride.claims_error[column.api_field_name]}}
                        </div>

                        <router-link v-if="ride.id_ride && ride.id_ride.id_ride && column.routerSelector && column.routerSelector(ride)" :to="column.routerSelector(ride)">
                          {{ (ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''}}
                          <br>
                        </router-link>
                        <div class="transaction-edit-cell dropdown" v-else-if="column.editable && column.type && ride.id_ride && ride.id_ride.id_ride">
                          <div class="dropdown-toggle" data-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false"  @click="setEnableEditField(ride, index, ride.id_ride[column.api_field_name]);">
                            {{ column.selector(ride) }}
                            <!-- <font-awesome-icon @click="showVehicleModel(ride.id_ride);" icon="edit" style="color: rgb(0, 0, 0); cursor: pointer"/> -->
                          </div>
                          <div class="dropdown-menu">
                            <div class="warning-msg"> {{ride.claims_error[column.api_field_name]}}</div>
                            <div style="display: flex; flex-direction: row; align-items: center; ">
                              <!-- <datetime v-if="column.type=='date'" type="datetime" v-model="edit_field_value" label="Pickup Time" input-class="form-control form-control-sm" placeholder="Pickup Time" ></datetime>
                              <input v-else autofocus v-model = "edit_field_value" class=" form-control" style="width:300px" /> -->
                              <input autofocus v-model = "edit_field_value" class=" form-control" style="width:300px" />

                              <font-awesome-icon class="close-dropdown-link" @click="setEnableEditField(null,null, null)" icon="times" style="float:right; margin:5px; color: rgb(239, 83, 80); cursor: pointer"/>
                              <font-awesome-icon class="close-dropdown-link" @click="updateRide(ride.id_ride)" icon="check" style="float:right; margin:5px; color: rgb(38, 166, 154); cursor: pointer"/>
                            </div>
                            <button v-for="(b, actionIndex) in column.actions" v-bind:key="actionIndex" class="btn btn-secondary close-dropdown-link" style="display:block;" @click="b.action(ride)">{{b.name}}</button>

                          </div>
                        </div>
                        <div v-else-if="column.name == 'Action'">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Action
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 2, getUnclaimableList)" href="#">Ready to submit</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 9, getUnclaimableList)" href="#">Ready to submit manually</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 3, getUnclaimableList)" href="#">Move to issue list</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 1, getUnclaimableList)" href="#">Ride not provided</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 6, getUnclaimableList)" href="#">Ride denied</a>
                              <a class="dropdown-item" @click="reverseRide(ride.id_ride, ride.id_transaction, getUnclaimableList)" href="#">Reverse Ride Payment</a>

                            </div>
                          </div>
                        </div>
                        <a v-else-if="column.click_action" @click="column.click_action(ride)">{{(ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''}}</a>


                        <span v-else v-html="(ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''"></span>


                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                  <div style="margin: 1rem 1rem; float: left;">
                    <span v-if="unclaimableRows > 0">Showing {{ perPage * (currentUnclaimablePage-1) + 1 }} to {{ perPage * currentUnclaimablePage > unclaimableRows ? unclaimableRows : perPage * currentUnclaimablePage }} of {{ unclaimableRows }} entries</span>
                    <span v-else>Showing 0 entries</span>                  </div>
                  <div style="margin: 0 1rem; float: right;">
                    <b-pagination style="margin: .5rem 0;" align="center" :total-rows=unclaimableRows v-model="currentUnclaimablePage" :per-page=perPage :limit=limit @change="changeUnclaimableTripsPage">
                    </b-pagination>
                  </div>
                </div>
              </div>
              <!-- DENIALS TAB -->
              <div class="tab-pane table-responsive" id="denied-trips-tab">
                <div class="tab-options">
                  <div>
                    <div class="table-header-filter" style="width: 200px">
                      <label>Page Size: </label>
                      <select v-model="perPage" class="form-control table-select" @change="getDeniedList(1)">
                        <option v-for="size in page_sizes" v-bind:key="size" v-bind:value="size">
                          {{size}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 255px">
                      <label>Provider: </label>
                      <select type="text" placeholder="Market" v-model="selected_provider"
                              class="form-control ddown" id="rider-filter" v-on:change="getDeniedList(1)">
                        <option value="all">All ({{ getClaimsCount(null, null, 'denied') }})</option>
                        <option v-for="item in data.markets" v-bind:key="item.id_market"  v-bind:value="item.id_market">
                          {{item.name}} ({{ getClaimsCount(item.name, null, 'denied') }})
                        </option>
                        <option value="deadhead">Deadhead ({{ getClaimsCount('Deadhead', null, 'denied') }})</option>

                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 370px">
                      <label>Activity Period: </label>
                      <select @change="getDeniedList()" v-model="selected_activity_period" class="form-control ddown">
                        <option value="all">All</option>
                        <option v-for="week in data.weeks" v-bind:value="week.week" v-bind:key="week.week">
                          {{ moment(week.monday).format('YYYY-MM-DD') +  ' - ' + moment(week.sunday).format('YYYY-MM-DD') }} ({{ getClaimsCount(null, moment(week.monday).format('YYYY-MM-DD'), 'denied') }})
                        </option>
                      </select>
                    </div>
                  </div>
                  <!-- <div class="col-12" style="display:inline;">
                    <a style="color: white; " class="btn submit-button" @click="generate_manual_submission(data.deniedList);">Generate Manual Submission</a>
                  </div> -->

                </div>
                <!-- <div style="position: absolute; right: 0; padding: 25px 20px; z-index:100;">
                  <div class="col-12" style="display:inline;">
                    <a style="color: white; " class="btn submit-button" @click="showConfirmManualSubmissionModal = true; submissionManualList = data.deniedList;">Generate Manual Submission</a>
                  </div>

                </div>  -->

                <div style="overflow-x:auto; min-height: 500px;">
                  <table class="table table-hover table-sm editable-table ">
                    <thead>
                      <tr>
                        <th class="result-label" style="min-width: 100px;">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Action
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a class="dropdown-item" @click="checkAll(data.deniedList)" href="#">Select All</a>
                              <a class="dropdown-item" @click="uncheckAll()" href="#">Select None</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(2, getDeniedList)" href="#">Move Selection to Ready to submit</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(4, getDeniedList)" href="#">Move Selection to Submitted</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(9, getDeniedList)" href="#">Move Selection to Ready to Submit Manually</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(8, getDeniedList)" href="#">Move Selection to Submitted Manually</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(10, getDeniedList)" href="#">Move Selection to Unclaimable</a>

                              <a class="dropdown-item" @click="bulkUpdateStatus(1, getDeniedList)" href="#">Move Selection to Not provided</a>
                              <a class="dropdown-item" @click="validateClaims(false, getDeniedList)" href="#">Validate SET Status of selection</a>

                            </div>
                          </div>
                        </th>
                        <th class="result-label" :class="'datatable-col-' + index" v-for="(column, index) in data.resultColumns" >
                          <div class="nowrap" style="" @click="sort('denials_' + column.sort_key, getDeniedList)" v-if="column.sort_key">
                            {{column.name}}
                            <div class="arrow-down" :ref="'denials_' + column.sort_key" :name="column.sort_key" :value="1" style="visibility: hidden; margin-left: 5px;"></div>
                          </div>
                          <div class="nowrap" style=""  v-if="!column.sort_key">
                            {{column.name}}
                            <div class="arrow-down" style="visibility: hidden; margin-left: 5px;"></div>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody class="col-12">
                    <tr v-for="ride in data.deniedList" v-bind:key="ride.id_transaction">
                      <td class="result-item text-center" width="80px">
                        <input type='checkbox' v-bind:value='ride.id_transaction' v-model='data.bulkSelection' v-bind:id="'bulk_select_' + ride.id_transaction">
                        <label class="search-label" v-bind:for="'bulk_select_' + ride.id_transaction" style="margin-bottom: 0; padding: 0px 0px 0px 26px; height: 15px;"></label>
                      </td>
                      <td class="result-item nowrap" :class="['datatable-col-' + index, (column.api_field_name && ride.claims_error[column.api_field_name]) ? 'error-cell' : '',(column.name && column.name == '_Action') ? 'mytooltip tooltip-effect-3' : '']" v-for="(column, index) in data.resultColumns" v-bind:key="column.name + '_'+ index" >
                        <div v-if="column.api_field_name && ride.claims_error[column.api_field_name] && column.name == '_Action'" class="tooltip-content clearfix">
                          {{ride.claims_error[column.api_field_name]}}
                        </div>

                        <router-link v-if="ride.id_ride && ride.id_ride.id_ride && column.routerSelector && column.routerSelector(ride)" :to="column.routerSelector(ride)">
                          {{ (ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''}}
                          <br>
                        </router-link>
                        <div class="transaction-edit-cell dropdown" v-else-if="column.editable && column.type && ride.id_ride && ride.id_ride.id_ride">
                          <div class="dropdown-toggle" data-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false"  @click="setEnableEditField(ride, index, ride.id_ride[column.api_field_name]);">
                            {{ column.selector(ride) }}
                            <!-- <font-awesome-icon @click="showVehicleModel(ride.id_ride);" icon="edit" style="color: rgb(0, 0, 0); cursor: pointer"/> -->
                          </div>
                          <div class="dropdown-menu">
                            <div class="warning-msg"> {{ride.claims_error[column.api_field_name]}}</div>
                            <div style="display: flex; flex-direction: row; align-items: center; ">
                              <!-- <datetime v-if="column.type=='date'" type="datetime" v-model="edit_field_value" label="Pickup Time" input-class="form-control form-control-sm" placeholder="Pickup Time" ></datetime>
                              <input v-else autofocus v-model = "edit_field_value" class=" form-control" style="width:300px" /> -->

                              <input autofocus v-model = "edit_field_value" class=" form-control" style="width:300px" />

                              <font-awesome-icon class="close-dropdown-link" @click="setEnableEditField(null,null, null)" icon="times" style="float:right; margin:5px; color: rgb(239, 83, 80); cursor: pointer"/>
                              <font-awesome-icon class="close-dropdown-link" @click="updateRide(ride.id_ride)" icon="check" style="float:right; margin:5px; color: rgb(38, 166, 154); cursor: pointer"/>
                            </div>
                            <button v-for="(b, actionIndex) in column.actions" v-bind:key="actionIndex" class="btn btn-secondary close-dropdown-link" style="display:block;" @click="b.action(ride)">{{b.name}}</button>

                          </div>
                        </div>
                        <div v-else-if="column.name == 'Action'">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Action
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 2, getDeniedList)" href="#">Ready to submit</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 9, getDeniedList)" href="#">Ready to submit manually</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 3, getDeniedList)" href="#">Move to issue list</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 1, getDeniedList)" href="#">Ride not provided</a>
                              <a class="dropdown-item" @click="reverseRide(ride.id_ride, ride.id_transaction, getDeniedList)" href="#">Reverse Ride Payment</a>



                            </div>
                          </div>
                        </div>
                        <a v-else-if="column.click_action" @click="column.click_action(ride)">{{(ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''}}</a>


                        <span v-else v-html="(ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''"></span>


                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                  <div style="margin: 1rem 1rem; float: left;">
                    <span v-if="deniedRows > 0">Showing {{ perPage * (currentDeniedPage-1) + 1 }} to {{ perPage * currentDeniedPage > deniedRows ? deniedRows : perPage * currentDeniedPage }} of {{ deniedRows }} entries</span>
                    <span v-else>Showing 0 entries</span>                  </div>
                  <div style="margin: 0 1rem; float: right;">
                    <b-pagination style="margin: .5rem 0;" align="center" :total-rows=deniedRows v-model="currentDeniedPage" :per-page=perPage :limit=limit @change="changeDeniedTripsPage">
                    </b-pagination>
                  </div>
                </div>
              </div>
              <!-- REJECTED (FTP) Tab -->
              <div class="tab-pane table-responsive" id="rejected-trips-tab">
                <div class="tab-options">
                  <div>
                    <div class="table-header-filter" style="width: 200px">
                      <label>Page Size: </label>
                      <select v-model="perPage" class="form-control table-select" @change="getRejectionsList(1)">
                        <option v-for="size in page_sizes" v-bind:key="size" v-bind:value="size">
                          {{size}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 255px">
                      <label>Provider: </label>
                      <select type="text" placeholder="Market" v-model="selected_provider"
                              class="form-control ddown" id="rider-filter" v-on:change="getRejectionsList(1)">
                        <option value="all">All ({{ getClaimsCount(null, null, 'rejected') }})</option>
                        <option v-for="item in data.markets" v-bind:key="item.id_market"  v-bind:value="item.id_market">
                          {{item.name}} ({{ getClaimsCount(item.name, null, 'rejected') }})
                        </option>
                        <option value="deadhead">Deadhead ({{ getClaimsCount('Deadhead', null, 'rejected') }})</option>

                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 370px">
                      <label>Activity Period: </label>
                      <select @change="getRejectionsList()" v-model="selected_activity_period" class="form-control ddown">
                        <option value="all">All</option>
                        <option v-for="week in data.weeks" v-bind:value="week.week" v-bind:key="week.week">
                          {{ moment(week.monday).format('YYYY-MM-DD') +  ' - ' + moment(week.sunday).format('YYYY-MM-DD') }} ({{ getClaimsCount(null, moment(week.monday).format('YYYY-MM-DD'), 'rejected') }})
                        </option>
                      </select>
                    </div>
                  </div>

                </div>
                <div style="overflow-x:auto; min-height: 500px;">
                  <table class="table table-hover table-sm editable-table ">
                    <thead>
                      <tr>
                        <th class="result-label" style="min-width: 100px;">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Action
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a class="dropdown-item" @click="checkAll(data.rejectionsList)" href="#">Select All</a>
                              <a class="dropdown-item" @click="uncheckAll()" href="#">Select None</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(2, getRejectionsList)" href="#">Move Selection to Ready to submit</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(4, getRejectionsList)" href="#">Move Selection to Submitted</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(9, getRejectionsList)" href="#">Move Selection to Ready to Submit Manually</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(8, getRejectionsList)" href="#">Move Selection to Submitted Manually</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(1, getRejectionsList)" href="#">Move Selection to Not provided</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(5, getRejectionsList)" href="#">Move Selection to Approved</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(10, getRejectionsList)" href="#">Move Selection to Unclaimable</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(11, getRejectionsList)" href="#">Move Selection to Waiting for replacement</a>
                              <a class="dropdown-item" @click="validateClaims(false, getRejectionsList)" href="#">Validate SET Status of selection</a>
                            </div>
                          </div>
                        </th>
                        <th class="result-label" :class="'datatable-col-' + index" v-for="(column, index) in data.resultColumns" >
                          <div class="nowrap" style="" @click="sort('rejections_' + column.sort_key, getRejectionsList)" v-if="column.sort_key">
                            {{column.name}}
                            <div class="arrow-down" :ref="'rejections_' + column.sort_key" :name="column.sort_key" :value="1" style="visibility: hidden; margin-left: 5px;"></div>
                          </div>
                          <div class="nowrap" style=""  v-if="!column.sort_key">
                            {{column.name}}
                            <div class="arrow-down" style="visibility: hidden; margin-left: 5px;"></div>
                          </div>

                        </th>
                      </tr>
                    </thead>
                    <tbody class="col-12">
                    <tr v-for="ride in data.rejectionsList" v-bind:key="ride.id_transaction">
                      <td class="result-item text-center" width="80px">
                        <input type='checkbox' v-bind:value='ride.id_transaction' v-model='data.bulkSelection' v-bind:id="'bulk_select_' + ride.id_transaction">
                        <label class="search-label" v-bind:for="'bulk_select_' + ride.id_transaction" style="margin-bottom: 0; padding: 0px 0px 0px 26px; height: 15px;"></label>
                      </td>
                      <td class="result-item nowrap" :class="['datatable-col-' + index, (column.api_field_name && ride.claims_error[column.api_field_name]) ? 'error-cell' : '',(column.name && column.name == '_Action') ? 'mytooltip tooltip-effect-3' : '']" v-for="(column, index) in data.resultColumns" v-bind:key="column.name + '_'+ index" >
                        <div v-if="column.api_field_name && ride.claims_error[column.api_field_name] && column.name == '_Action'" class="tooltip-content clearfix">
                          {{ride.claims_error[column.api_field_name]}}
                        </div>

                        <router-link v-if="ride.id_ride && ride.id_ride.id_ride && column.routerSelector && column.routerSelector(ride)" :to="column.routerSelector(ride)">
                          {{ (ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''}}
                          <br>
                        </router-link>
                        <div class="transaction-edit-cell dropdown" v-else-if="column.editable && column.type && ride.id_ride && ride.id_ride.id_ride">
                          <div class="dropdown-toggle" data-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false"  @click="setEnableEditField(ride, index, ride.id_ride[column.api_field_name]);">
                            {{ column.selector(ride) }}
                            <!-- <font-awesome-icon @click="showVehicleModel(ride.id_ride);" icon="edit" style="color: rgb(0, 0, 0); cursor: pointer"/> -->
                          </div>
                          <div class="dropdown-menu">
                            <div class="warning-msg"> {{ride.claims_error[column.api_field_name]}}</div>
                            <div style="display: flex; flex-direction: row; align-items: center; ">
                              <!-- <datetime v-if="column.type=='date'" type="datetime" v-model="edit_field_value" label="Pickup Time" input-class="form-control form-control-sm" placeholder="Pickup Time" ></datetime>
                              <input v-else autofocus v-model = "edit_field_value" class=" form-control" style="width:300px" /> -->

                              <input autofocus v-model = "edit_field_value" class=" form-control" style="width:300px" />

                              <font-awesome-icon class="close-dropdown-link" @click="setEnableEditField(null,null, null)" icon="times" style="float:right; margin:5px; color: rgb(239, 83, 80); cursor: pointer"/>
                              <font-awesome-icon class="close-dropdown-link" @click="updateRide(ride.id_ride)" icon="check" style="float:right; margin:5px; color: rgb(38, 166, 154); cursor: pointer"/>
                            </div>
                            <button v-for="(b, actionIndex) in column.actions" v-bind:key="actionIndex" class="btn btn-secondary close-dropdown-link" style="display:block;" @click="b.action(ride)">{{b.name}}</button>

                          </div>
                        </div>
                        <div v-else-if="column.name == 'Action'">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Action
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 2, getRejectionsList)" href="#">Ready to submit</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 9, getRejectionsList)" href="#">Ready to submit manually</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 3, getRejectionsList)" href="#">Move to issue list</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 1, getRejectionsList)" href="#">Ride not provided</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 11, getRejectionsList)" href="#">Wait for replacement</a>
                              <a class="dropdown-item" @click="reverseRide(ride.id_ride, ride.id_transaction, getRejectionsList)" href="#">Reverse Ride Payment</a>

                            </div>
                          </div>
                        </div>
                        <a v-else-if="column.click_action" @click="column.click_action(ride)">{{(ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''}}</a>


                        <span v-else v-html="(ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''"></span>


                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                  <div style="margin: 1rem 1rem; float: left;">
                    <span v-if="rejectionRows > 0">Showing {{ perPage * (currentRejectionsPage-1) + 1 }} to {{ perPage * currentRejectionsPage > rejectionRows ? rejectionRows : perPage * currentRejectionsPage }} of {{ rejectionRows }} entries</span>
                    <span v-else>Showing 0 entries</span>                  </div>
                  <div style="margin: 0 1rem; float: right;">
                    <b-pagination style="margin: .5rem 0;" align="center" :total-rows=rejectionRows v-model="currentRejectionsPage" :per-page=perPage :limit=limit @change="changeRejectedTripsPage">
                    </b-pagination>
                  </div>
                </div>
              </div>
              <!-- All Trips -->
              <div class="tab-pane table-responsive" id="all-trips-tab">
                <div class="tab-options">
                  <div>
                    <div class="table-header-filter" style="width: 200px">
                      <label>Page Size: </label>
                      <select v-model="perPage" class="form-control table-select" @change="getAllTripsList(1)">
                        <option v-for="size in page_sizes" v-bind:key="size" v-bind:value="size">
                          {{size}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 235px">
                      <label>Provider: </label>
                      <select type="text" placeholder="Market" v-model="selected_provider"
                              class="form-control ddown" id="rider-filter" v-on:change="getAllTripsList(1)">
                        <option value="all">All ({{ getClaimsCount(null, null, null) }})</option>
                        <option v-for="item in data.markets" v-bind:key="item.id_market"  v-bind:value="item.id_market">
                          {{item.name}} ({{ getClaimsCount(item.name, null, null) }})
                        </option>
                        <option value="deadhead">Deadhead ({{ getClaimsCount('Deadhead', null,  null) }})</option>

                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 360px">
                      <label>Claims Status: </label>
                      <select type="text" placeholder="Market" v-model="search_claim_status" class="form-control ddown" id="rider-filter" v-on:change="getAllTripsList()">
                        <option value="all">All ({{ getClaimsCount(null, null,  null) }})</option>
                        <option value="1">Not provided ({{ getClaimsCount(null, null,  'not_provided') }})</option>
                        <option value="2">Ready to submit ({{ getClaimsCount(null, null,  'ready_to_submit') }})</option>
                        <option value="9">Ready to submit manually ({{ getClaimsCount(null, null,  'ready_to_submit_manually') }})</option>
                        <option value="3">Warning ({{ getClaimsCount(null, null,  'warning') }})</option>
                        <option value="4">Submitted ({{ getClaimsCount(null, null,  'submitted') }})</option>
                        <option value="8">Submitted manually ({{ getClaimsCount(null, null,  'submitted_manually') }})</option>
                        <option value="5">Approved ({{ getClaimsCount(null, null,  'approved') }})</option>
                        <option value="6">Denied ({{ getClaimsCount(null, null,  'denied') }})</option>
                        <option value="7">Rejected ({{ getClaimsCount(null, null,  'rejected') }})</option>
                        <option value="10">Unclaimable ({{ getClaimsCount(null, null,  'unclaimable') }})</option>
                        <option value="11">Waiting for replacement ({{ getClaimsCount(null, null,  'waiting_for_replacement') }})</option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 370px">
                      <label>Activity Period: </label>
                      <select @change="getAllTripsList()" v-model="selected_activity_period" class="form-control ddown">
                        <option value="all">All</option>
                        <option v-for="week in data.weeks" v-bind:value="week.week" v-bind:key="week.week">
                          {{ moment(week.monday).format('YYYY-MM-DD') +  ' - ' + moment(week.sunday).format('YYYY-MM-DD') }} ({{ getClaimsCount(null, moment(week.monday).format('YYYY-MM-DD'), null) }})
                        </option>
                      </select>
                    </div>
                  </div>
                  <div style="position: absolute; right: 0; padding: 0px 20px; z-index:100; margin: 0px 15px;">
                      <a style="color: white" class="btn submit-button" @click="validateClaims(data.allTripsList, getAllTripsList)">Validate SET Status</a>
                      <a style="color: white" class="btn submit-button" @click="resetClaimsStatus()">Reset Claims Status</a>
                  </div>
                </div>
                <div style="overflow-x:auto; min-height: 550px;">
                  <table class="table table-hover table-sm editable-table ">
                    <thead>
                      <tr>
                        <th class="result-label" style="min-width: 100px;">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Action
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a class="dropdown-item" @click="checkAll(data.allTripsList)" href="#">Select All</a>
                              <a class="dropdown-item" @click="uncheckAll()" href="#">Select None</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(2, getAllTripsList)" href="#">Move Selection to Ready to submit</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(9, getAllTripsList)" href="#">Move Selection to Ready to submit Manually</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(3, getAllTripsList)" href="#">Move Selection to Issues List</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(4, getAllTripsList)" href="#">Move Selection to Submitted</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(8, getAllTripsList)" href="#">Move Selection to Submitted Manually</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(5, getAllTripsList)" href="#">Move Selection to Approved</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(6, getAllTripsList)" href="#">Move Selection to Denied</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(7, getAllTripsList)" href="#">Move Selection to Rejected</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(1, getAllTripsList)" href="#">Move Selection to Not provided</a>
                              <a class="dropdown-item" @click="bulkUpdateStatus(11, getAllTripsList)" href="#">Move Selection to Waiting for replacement</a>
                              <a class="dropdown-item" @click="validateClaims(false, getAllTripsList)" href="#">Validate SET Status of selection</a>

                            </div>
                          </div>
                        </th>
                        <th class="result-label" :class="'datatable-col-' + index" v-for="(column, index) in data.resultColumns" >
                          <div class="nowrap" style="" @click="sort('allTrips_' + column.sort_key, getAllTripsList)" v-if="column.sort_key">
                            {{column.name}}
                            <div class="arrow-down" :ref="'allTrips_' + column.sort_key" :name="column.sort_key" :value="1" style="visibility: hidden; margin-left: 5px;"></div>
                          </div>
                          <div class="nowrap" style=""  v-if="!column.sort_key">
                            {{column.name}}
                            <div class="arrow-down" style="visibility: hidden; margin-left: 5px;"></div>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody class="col-12">
                    <tr v-for="ride in data.allTripsList" v-bind:key="ride.id_transaction">
                      <td class="result-item text-center" width="80px">
                        <input type='checkbox' v-bind:value='ride.id_transaction' v-model='data.bulkSelection' v-bind:id="'bulk_select_' + ride.id_transaction">
                        <label class="search-label" v-bind:for="'bulk_select_' + ride.id_transaction" style="margin-bottom: 0; padding: 0px 0px 0px 26px; height: 15px;"></label>
                      </td>
                      <td class="result-item nowrap" :class="['datatable-col-' + index, (column.api_field_name && ride.claims_error[column.api_field_name]) ? 'error-cell' : '',(column.name && column.name == '_Action') ? 'mytooltip tooltip-effect-3' : '']" v-for="(column, index) in data.resultColumns" v-bind:key="column.name + '_'+ index" >
                        <div v-if="column.api_field_name && ride.claims_error[column.api_field_name] && column.name == '_Action'" class="tooltip-content clearfix">
                          {{ride.claims_error[column.api_field_name]}}
                        </div>

                        <router-link v-if="ride.id_ride && ride.id_ride.id_ride && column.routerSelector && column.routerSelector(ride)" :to="column.routerSelector(ride)">
                          {{ (ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''}}
                          <br>
                        </router-link>
                        <div class="transaction-edit-cell dropdown" v-else-if="column.editable && column.type && ride.id_ride && ride.id_ride.id_ride">
                          <div class="dropdown-toggle" data-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false"  @click="setEnableEditField(ride, index, ride.id_ride[column.api_field_name]);">
                            {{ column.selector(ride) }}
                            <!-- <font-awesome-icon @click="showVehicleModel(ride.id_ride);" icon="edit" style="color: rgb(0, 0, 0); cursor: pointer"/> -->
                          </div>
                          <div class="dropdown-menu">
                            <div class="warning-msg"> {{ride.claims_error[column.api_field_name]}}</div>
                            <div style="display: flex; flex-direction: row; align-items: center; ">
                              <!-- <datetime v-if="column.type=='date'" type="datetime" v-model="edit_field_value" label="Pickup Time" input-class="form-control form-control-sm" placeholder="Pickup Time" ></datetime>
                              <input v-else autofocus v-model = "edit_field_value" class=" form-control" style="width:300px" /> -->

                              <input autofocus v-model = "edit_field_value" class=" form-control" style="width:300px" />

                              <font-awesome-icon class="close-dropdown-link" @click="setEnableEditField(null,null, null)" icon="times" style="float:right; margin:5px; color: rgb(239, 83, 80); cursor: pointer"/>
                              <font-awesome-icon class="close-dropdown-link" @click="updateRide(ride.id_ride)" icon="check" style="float:right; margin:5px; color: rgb(38, 166, 154); cursor: pointer"/>
                            </div>
                            <button v-for="(b, actionIndex) in column.actions" v-bind:key="actionIndex" class="btn btn-secondary close-dropdown-link" style="display:block;" @click="b.action(ride)">{{b.name}}</button>

                          </div>
                        </div>
                        <div v-else-if="column.name == 'Action'">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Action
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 2, getAllTripsList)" href="#">Ready to submit</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 3, getAllTripsList)" href="#">Move to issue list</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 7, getAllTripsList)" href="#">Rejected FTP</a>
                              <a class="dropdown-item" @click="updateClaimStatus(ride.id_transaction, 1, getAllTripsList)" href="#">Ride not provided</a>
                            </div>
                          </div>
                        </div>
                        <a v-else-if="column.click_action" @click="column.click_action(ride)">{{(ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''}}</a>


                        <span v-else v-html="(ride.id_ride && ride.id_ride.id_ride) ? column.selector(ride) : ''"></span>

                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                  <div style="margin: 1rem 1rem; float: left;">
                    <span v-if="totalAllTripsRows > 0">Showing {{ perPage * (currentAllTripsPage-1) + 1 }} to {{ perPage * currentAllTripsPage > totalAllTripsRows ? totalAllTripsRows : perPage * currentAllTripsPage }} of {{ totalAllTripsRows }} entries</span>
                    <span v-else>Showing 0 entries</span>                  </div>
                  <div style="margin: 0 1rem; float: right;">
                    <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalAllTripsRows v-model="currentAllTripsPage" :per-page=perPage :limit=limit @change="changeAllTripsPage">
                    </b-pagination>
                  </div>
                </div>

              </div>
              <!-- Platform Fee Only -->
              <div class="tab-pane table-responsive" id="platform-fee-only-tab">
                <div class="tab-options">
                  <div>
                    <div class="table-header-filter" style="width: 200px">
                      <label>Page Size: </label>
                      <select v-model="perPage" class="form-control table-select" @change="getPlatformFeeOnlyRides(1)">
                        <option v-for="size in page_sizes" v-bind:key="size" v-bind:value="size">
                          {{size}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 255px">
                      <label>Provider: </label>
                      <select type="text" placeholder="Market" v-model="selected_provider"
                              class="form-control ddown" id="rider-filter" v-on:change="getPlatformFeeOnlyRides(1)">
                        <option v-for="item in data.markets" v-bind:key="item.id_market"  v-bind:value="item.id_market">
                          {{item.name}}
                        </option>
                        <option value="deadhead">Deadhead</option>

                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 360px">
                      <label>Claims Status: </label>
                      <select type="text" placeholder="Market" v-model="search_claim_status" class="form-control ddown" id="rider-filter" v-on:change="getPlatformFeeOnlyRides(1)">
                        <option value="all">All</option>
                        <option value="1">Not provided</option>
                        <option value="2">Ready to submit</option>
                        <option value="9">Ready to submit manually</option>
                        <option value="3">Warning</option>
                        <option value="4">Submitted</option>
                        <option value="8">Submitted manually</option>
                        <option value="5">Approved</option>
                        <option value="6">Denied</option>
                        <option value="7">Rejected</option>
                        <option value="10">Unclaimable</option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 370px">
                      <label>Activity Period: </label>
                      <select @change="getPlatformFeeOnlyRides(1)" v-model="selected_activity_period" class="form-control ddown">
                        <option value="all">All</option>
                        <option v-for="week in data.weeks" v-bind:value="week.week" v-bind:key="week.week">
                          {{ moment(week.monday).format('YYYY-MM-DD') +  ' - ' + moment(week.sunday).format('YYYY-MM-DD') }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div style="position: absolute; right: 0; padding: 0px 20px; z-index:100;">
                  <div class="col-12" style="display:inline;">
                      <a style="color: white; " class="btn submit-button" @click="showConfirmAdditionalManualSubmissionModal = true; ">Generate Manual Submission</a>
                    </div>
                  </div>
                </div>

                <div style="overflow-x:auto;">
                  <table class="table table-hover table-sm editable-table ">
                    <thead>
                      <tr>
                        <th class="result-label" style="min-width: 100px;">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Action
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a class="dropdown-item" @click="checkAll(data.plaformFeeOnlyList)" href="#">Select All</a>
                              <a class="dropdown-item" @click="uncheckAll()" href="#">Select None</a>
                            </div>
                          </div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Ride ID</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Trip Leg ID</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Pickup Date</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Driver Name</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Contact Name</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Price Total</div>
                        </th>
                        <!--<th class="result-label" >-->
                          <!--<div class="nowrap" style="">Platform Fee</div>-->
                        <!--</th>-->
                        <th class="result-label" >
                          <div class="nowrap" style="">Additional Payment</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Unloaded Payment</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Paid Total</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Claims Status</div>
                        </th>
                        <th class="result-label" v-if="search_claim_status == '6' || search_claim_status == '9'">
                          <div class="nowrap" style="">Denial Reason</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Ride Status</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Ride Type</div>
                        </th>

                      </tr>
                    </thead>
                    <tbody class="col-12">
                    <tr v-for="tran in data.plaformFeeOnlyList" v-bind:key="tran.id_ride.id_ride">
                      <td class="result-item text-center" width="80px">
                        <input type='checkbox' v-bind:value='tran.id_transaction' v-model='data.bulkSelection' v-bind:id="'bulk_select_' + tran.id_transaction">
                        <label class="search-label" v-bind:for="'bulk_select_' + tran.id_transaction" style="margin-bottom: 0; padding: 0px 0px 0px 26px; height: 15px;"></label>
                      </td>
                      <td class="result-item nowrap">
                       <router-link  :to="'/rides/' + tran.id_ride.id_ride + '/' ">
                          {{tran.id_ride.id_ride}}
                          <br>
                        </router-link>
                      </td>
                      <td class="result-item nowrap">
                       <router-link  :to="'/rides/' + tran.id_ride.id_ride + '/' ">
                          {{tran.id_ride.id_alternate}}
                          <br>
                        </router-link>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{moment.utc(tran.id_ride.date_pickup).format('MM/DD/YY  HH:mm z')}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{tran.to_id_user ? tran.to_id_user.name_first : 'N/A'}} {{tran.to_id_user ? tran.to_id_user.name_last : ''}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{tran.id_ride.contact_first_name + ' ' + tran.id_ride.contact_last_name}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{tran.id_ride.price_total}}</span>
                      </td>
                      <!--<td class="result-item nowrap">-->
                        <!--<span>{{ride.claim_info.platform_fee}}</span>-->
                      <!--</td>-->
                      <td class="result-item nowrap">
                        <span>{{tran.id_ride.price_additional}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{tran.id_ride.price_unloaded}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{tran.claims_amount}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{tran.id_type_claims_status ? tran.id_type_claims_status.code : 'N/A'}}</span>
                      </td>
                      <td class="result-item nowrap" v-if="search_claim_status == '6' || search_claim_status == '9'">
                        <span>{{tran.denial_reason ? tran.denial_reason : ''}}</span>
                      </td>


                      <td class="result-item nowrap">
                        <span>{{tran.id_ride.id_type_ride_status? tran.id_ride.id_type_ride_status.code : 'N/A'}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{tran.id_ride.deadhead ? 'deadhead' : 'regular'}}</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                  <div style="margin: 1rem 1rem; float: left;">
                    <span v-if="totalPlatformFeeRows > 0">Showing {{ perPage * (currentPlatformFeePage-1) + 1 }} to {{ perPage * currentPlatformFeePage > totalPlatformFeeRows ? totalPlatformFeeRows : perPage * currentPlatformFeePage }} of {{ totalPlatformFeeRows }} entries</span>
                    <span v-else>Showing 0 entries</span>                  </div>
                  <div style="margin: 0 1rem; float: right;">
                    <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalPlatformFeeRows v-model="currentPlatformFeePage" :per-page=perPage :limit=limit @change="changePlatformFeePage">
                    </b-pagination>
                  </div>
                </div>

              </div>
             <!-- OLD DROPOFFS - SUBMITTED BUT NO RESPONSE -->
              <div class="tab-pane table-responsive" id="no-response-tab">
                <div class="tab-options">
                  <div>
                    <div class="table-header-filter" style="width: 200px">
                      <label>Page Size: </label>
                      <select v-model="perPage" class="form-control table-select" @change="getNoResponseList(1)">
                        <option v-for="size in page_sizes" v-bind:key="size" v-bind:value="size">
                          {{size}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="table-header-filter" style="width: 255px">
                      <label>Provider: </label>
                      <select type="text" placeholder="Market" v-model="selected_provider"
                              class="form-control ddown" id="rider-filter" v-on:change="getNoResponseList(1)">
                        <option value="all">All</option>
                        <option v-for="item in data.markets" v-bind:key="item.id_market"  v-bind:value="item.id_market">
                          {{item.name}}
                        </option>
                        <option value="deadhead">Deadhead</option>

                      </select>
                    </div>
                  </div>
                  <div style="position: absolute; right: 0; padding: 0px 20px; z-index:100;">
                    <div class="col-12" style="display:inline;">
                      <a style="color: white; " class="btn submit-button" @click="showConfirmNoResponseSubmissionModal = true; submissionManualList = data.noResponseList;">Generate Manual Submission</a>
                    </div>
                  </div>

                </div>
                  <!-- <div class="col-12" style="display:inline;">
                    <a style="color: white;" class="btn submit-button" @click="showConfirmSubmissionModal=true;">Submit to Claims</a>
                  </div> -->
                <div style="overflow-x:auto; min-height: 300px;">
                  <table class="table table-hover table-sm editable-table ">
                    <thead>
                      <tr>
                        <th class="result-label" >
                          <div class="nowrap" style="">Ride ID</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Trip Leg ID</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Provider</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Pickup Date</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Driver Name</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Contact Name</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Price Total</div>
                        </th>
                        <!--<th class="result-label" >-->
                          <!--<div class="nowrap" style="">Platform Fee</div>-->
                        <!--</th>-->
                        <th class="result-label" >
                          <div class="nowrap" style="">Additional Payment</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Unloaded Payment</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Ride Status</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Claims Status</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Last Submitted</div>
                        </th>


                      </tr>
                    </thead>
                    <tbody class="col-12">
                    <tr v-for="ride in data.noResponseList" v-bind:key="ride.id_ride">
                      <td class="result-item nowrap">
                       <router-link  :to="'/rides/' + ride.id_ride + '/' ">
                          {{ride.id_ride}}
                          <br>
                        </router-link>
                      </td>
                      <td class="result-item nowrap">
                       <router-link  :to="'/rides/' + ride.id_ride + '/' ">
                          {{ride.id_alternate}}
                          <br>
                        </router-link>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{ride.deadhead ? 'Deadhead' : ride.id_market.name}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{moment.utc(ride.date_pickup).format('MM/DD/YY  HH:mm z')}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{ride.id_driver ? ride.id_driver.name_first : 'N/A'}} {{ride.id_driver ? ride.id_driver.name_last : ''}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{ride.contact_first_name + ' ' + ride.contact_last_name}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{ride.price_total}}</span>
                      </td>
                      <!--<td class="result-item nowrap">-->
                        <!--<span>{{ride.claim_info.platform_fee}}</span>-->
                      <!--</td>-->
                      <td class="result-item nowrap">
                        <span>{{ride.price_additional ? ride.price_additional : 0}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{ride.price_unloaded ? ride.price_unloaded : 0}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{ride.id_type_ride_status.name}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{ (ride.claims && ride.claims.name) ? ride.claims.name : 'N/A'}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{ (ride.claims && ride.claims.last_submitted_at) ? moment.utc(ride.claims.last_submitted_at).format('MM/DD/YY  HH:mm z') : 'N/A'}}</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                  <div style="margin: 1rem 1rem; float: left;">
                    <!-- <span v-if="totalRows > 0">Showing {{ data.readyToSubmitList.length }} entries</span> -->
                    <span v-if="totalNoResponseRows > 0">Showing {{ perPage * (currentNoResponsePage-1) + 1 }} to {{ perPage * currentNoResponsePage > totalNoResponseRows ? totalNoResponseRows : perPage * currentNoResponsePage }} of {{ totalNoResponseRows }} entries</span>
                    <span v-else>Showing 0 entries</span>
                  </div>
                  <div style="margin: 0 1rem; float: right;">
                    <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalNoResponseRows v-model="currentNoResponsePage" :per-page=perPage :limit=perPage @change="changeNoResponsePage">
                    </b-pagination>
                  </div>


                </div>
              </div>
              <!-- Submissions -->
              <div class="tab-pane table-responsive" id="submissions-tab">
                <div class="tab-options">
                </div>
                <div style="overflow-x:auto;">
                  <table class="table table-hover table-sm editable-table ">
                    <thead>
                      <tr>
                        <th class="result-label" >
                          <div class="nowrap" style="">ID</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Filename</div>
                        </th>
                        <th class="result-label" >
                          <div  style="">Description</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Submission Date</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Submitted By</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Rejection Sync Date</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">Rejection Synced By</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">SET Sync Date</div>
                        </th>
                        <th class="result-label" >
                          <div class="nowrap" style="">SET Synced By</div>
                        </th>

                        <th class="result-label" style="min-width: 100px;" >
                          <div class="nowrap" style="">Action</div>
                        </th>

                      </tr>
                    </thead>
                    <tbody class="col-12">
                    <tr v-for="submission in data.submissionsList" v-bind:key="submission.id">
                      <td class="result-item nowrap">
                        <span>{{submission.id}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <a :href="submission.url" target="_blank">{{submission.filename}}</a>
                      </td>
                      <td class="result-item ">
                        <span v-html="replaceURLWithHTMLLinks(submission.description)"></span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{moment.utc(submission.created_at).format('MM/DD/YY  HH:mm z')}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{submission.id_user.name_first + ' ' + submission.id_user.name_last}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{(!submission.checked_ftp_at)  ? '' :moment.utc(submission.checked_ftp_at).format('MM/DD/YY  HH:mm z')}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{(!submission.checked_ftp_by)  ? '' :submission.checked_ftp_by.name_first + ' ' + submission.checked_ftp_by.name_last}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{(!submission.checked_set_at)  ? '' :moment.utc(submission.checked_set_at).format('MM/DD/YY  HH:mm z')}}</span>
                      </td>
                      <td class="result-item nowrap">
                        <span>{{(!submission.checked_set_by)  ? '' : submission.checked_set_by.name_first + ' ' + submission.checked_set_by.name_last}}</span>
                      </td>


                      <td>
                        <div >
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Action
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a v-if="!submission.filename.startsWith('manual')" class="dropdown-item" @click="syncSubmissionRejections(submission.id)" href="#">Sync Rejection Reasons</a>
                              <a class="dropdown-item" @click="syncSubmissionSETStatus(submission.id)" href="#">Sync SET Status</a>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                  <div style="margin: 1rem 1rem; float: left;">
                    <span v-if="totalSubmissionRows > 0">Showing {{ perPage * (currentSubmissionsPage-1) + 1 }} to {{ perPage * currentSubmissionsPage > totalSubmissionRows ? totalSubmissionRows : perPage * currentSubmissionsPage }} of {{ totalSubmissionRows }} entries</span>
                    <span v-else>Showing 0 entries</span>                  </div>
                  <div style="margin: 0 1rem; float: right;">
                    <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalSubmissionRows v-model="currentSubmissionsPage" :per-page=perPage :limit=limit @change="changeSubmissionsPage">
                    </b-pagination>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Confirm submission popup -->
    <div>
      <div>
        <!-- use the modal component, pass in the prop -->
        <modal v-if="showConfirmSubmissionModal" @close="showConfirmSubmissionModal = false">
          <h3 slot="header">
            Please confirm your claims submission.
          </h3>
          <div slot="body">
            <form v-on:submit.prevent class="form-material">
              <div class="switch">
                  <label>Test<input v-model="submissionProductionMode" type="checkbox" ><span class="lever"></span>Production</label>
              </div>
              <textarea v-model="submissionComment" class="form-control" placeholder="Please add a comment for this submission" style="width:100%; height: 200px;  border-radius: 8px; "></textarea>

            </form>
          </div>
          <div slot="footer" >
            <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showConfirmSubmissionModal = false; submitClaims()">
              Submit
            </button>
            <button class="modal-default-button btn btn-default m-t-10" @click="showConfirmSubmissionModal = false; isLoading = false">
              Cancel
            </button>
          </div>
        </modal>
      </div>
    </div>

    <!-- Confirm manual submission popup -->
    <div>
      <div>
        <!-- use the modal component, pass in the prop -->
        <modal v-if="showConfirmManualSubmissionModal" @close="showConfirmManualSubmissionModal = false">
          <h3 slot="header">
            Please confirm your manual claims submission.
          </h3>
          <div slot="body">
            <form v-on:submit.prevent class="form-material">
              <div class="switch">
                  <label><input v-model="submissionManualMode" type="checkbox" ><span class="lever"></span>Update claims status to Manually Submitted</label>
              </div>
              <textarea v-model="manualSubmissionComment" class="form-control" placeholder="Please add a comment for this manual submission" style="width:100%; height: 200px;  border-radius: 8px; "></textarea>

            </form>
          </div>
          <div slot="footer" >
            <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showConfirmManualSubmissionModal = false; generate_manual_submission(submissionManualList);">
              Submit
            </button>
            <button class="modal-default-button btn btn-default m-t-10" @click="showConfirmManualSubmissionModal = false; isLoading = false">
              Cancel
            </button>
          </div>
        </modal>
      </div>
    </div>

    <!-- Confirm additional payments manual submission popup -->
    <div>
      <div>
        <!-- use the modal component, pass in the prop -->
        <modal v-if="showConfirmAdditionalManualSubmissionModal" @close="showConfirmAdditionalManualSubmissionModal = false">
          <h3 slot="header">
            Please confirm your manual claims submission.
          </h3>
          <div slot="body">
            <form v-on:submit.prevent class="form-material">
              <div class="switch">
                <label><input v-model="submissionManualMode" type="checkbox" ><span class="lever"></span>Update claims status to Manually Submitted</label>
              </div>
              <textarea v-model="manualSubmissionComment" class="form-control" placeholder="Please add a comment for this manual submission" style="width:100%; height: 200px;  border-radius: 8px; "></textarea>

            </form>
          </div>
          <div slot="footer" >
            <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showConfirmAdditionalManualSubmissionModal = false; generate_platform_fee_manual_submission()">
              Submit
            </button>
            <button class="modal-default-button btn btn-default m-t-10" @click="showConfirmAdditionalManualSubmissionModal = false; isLoading = false">
              Cancel
            </button>
          </div>
        </modal>
      </div>
    </div>

   <!-- Confirm additional payments manual submission popup -->
    <div>
      <div>
        <!-- use the modal component, pass in the prop -->
        <modal v-if="showConfirmNoResponseSubmissionModal" @close="showConfirmNoResponseSubmissionModal = false">
          <h3 slot="header">
            Please confirm your manual claims submission.
          </h3>
          <div slot="body">
            <form v-on:submit.prevent class="form-material">
              <div class="switch">
                <label><input v-model="submissionManualMode" type="checkbox" ><span class="lever"></span>Update claims status to Manually Submitted</label>
              </div>
              <textarea v-model="manualSubmissionComment" class="form-control" placeholder="Please add a comment for this manual submission" style="width:100%; height: 200px;  border-radius: 8px; "></textarea>

            </form>
          </div>
          <div slot="footer" >
            <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showConfirmNoResponseSubmissionModal = false; generate_no_response_manual_submission()">
              Submit
            </button>
            <button class="modal-default-button btn btn-default m-t-10" @click="showConfirmNoResponseSubmissionModal = false; isLoading = false">
              Cancel
            </button>
          </div>
        </modal>
      </div>
    </div>

    <!-- vehicle selection popup -->
    <div>
      <div>
        <!-- use the modal component, pass in the prop -->
        <modal v-if="showVehicleSelectModal" @close="showVehicleSelectModal = false">
          <h3 slot="header">
            Please select a vehicle for this ride
          </h3>
          <div slot="body">
            <form v-on:submit.prevent class="form-material">
              <br>
              <br>
              <select id="driver-selection" type="text" placeholder="Driver"
                      class="form-control ddown" v-model="selected_vehicle">
                <option v-for="(item) in data.currentRideVehicles" v-bind:value="item.id_vehicle">
                  {{ (item.vin + " " + item.id_make_vehicle.name  + " - " + item.model + " " ) + " from " + (item.created_at ? moment(item.created_at).format('MM/DD/YY'): "?") + " to " +  (item.deleted_at ? moment(item.deleted_at).format('MM/DD/YY'): "Present") }}
                </option>
              </select>
            </form>
          </div>
          <div slot="footer" >
            <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showVehicleSelectModal = false; updateVehicle()">
              Submit
            </button>
            <button class="modal-default-button btn btn-default m-t-10" @click="showVehicleSelectModal = false; isLoading = false">
              Cancel
            </button>
          </div>
        </modal>
      </div>
    </div>
    <!-- event log selection popup -->
    <div class="event-log-modal">
        <!-- use the modal component, pass in the prop -->
        <modal v-if="showEventLogSelectModal" @close="showEventLogSelectModal = false">
          <h3 slot="header">
            <span v-if="this.data.resultColumns[this.edit_field_index].api_type == 'geostamp' ">Please select the timestamp from the event log</span>
            <span v-if="this.data.resultColumns[this.edit_field_index].api_type == 'pickup_geo' || this.data.resultColumns[this.edit_field_index].api_type == 'dropoff_geo' ">Please select Lat/Lng from the event log</span>
          <button class="modal-default-button btn btn-default m-t-10" @click="showEventLogSelectModal = false; isLoading = false">
              <i class="fa fa-times"></i>
            </button>

          </h3>
          <div slot="body">
            <form v-on:submit.prevent class="form-material">
              <table class="table table-sm table-hover">
                <thead>
                <tr>
                  <th>Profile</th>
                  <th>At</th>
                  <th>Ride Status</th>
                  <th>Description</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="event in data.currentRideDetail.ride_events" v-bind:key="event.id_ride_event">
                  <td>
                    <router-link :to="'/users/' + event.id_user.id_user + '/'">
                      {{ event.id_user ? (event.id_user.name_first ? event.id_user.name_first : '') + ' ' + (event.id_user.name_last ? event.id_user.name_last : '') : event.user_type ? event.user_type : 'N/A' }}
                    </router-link>
                  </td>
                  <td>
                    <!--{{ moment(event.created_at).format("YYYY-MM-DD HH:mm") + " (" + moment.tz(moment.tz.guess()).format('z') + ")" }}-->
                    {{ !event.created_at ? 'N/A' : data.currentRideDetail.local_timezone ? moment.utc(event.created_at).tz(data.currentRideDetail.local_timezone).format('MM/DD/YYYY HH:mm z') : moment.utc(event.created_at).format('MM/DD/YYYY HH:mm z')}}
                  </td>
                  <td>{{ event.id_type_ride_status ? (event.id_type_ride_status.name ? event.id_type_ride_status.name : event.id_type_ride_status.code ? event.id_type_ride_status.code : 'N/A') : 'N/A' }}</td>
                  <td>{{ event.description ? event.description : 'N/A' }}</td>
                  <td width="130px">
                    <button v-if="data.resultColumns[edit_field_index].api_type == 'geostamp'" class="btn btn-secondary close-dropdown-link" style="display:block;" @click="updateRideFromEventLog(data.currentRideDetail, event)" >Use timestamp</button>
                    <button v-if="(data.resultColumns[edit_field_index].api_type == 'pickup_geo' || data.resultColumns[edit_field_index].api_type == 'dropoff_geo') && getLatLngFromComment(event.description)" class="btn btn-secondary close-dropdown-link" style="display:block;" @click="updateRideFromEventLog(data.currentRideDetail, event)" >Use GPS</button>
                  </td>
                </tr>
                <tr v-if="data.currentRideDetail.ride_events.length==0" style="text-align: center;">
                  <td colspan="6">N/A</td>
                </tr>
                </tbody>
              </table>
            </form>
          </div>
          <div slot="footer" >

          </div>
        </modal>
      </div>
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'
  import moment from 'moment';
  export default {
    metaInfo: {
      title: 'Wingz Support | Claims Processing',
    },
    name: "ClaimsProcessing",
    data () {
      return {
        title: 'Claims Processing',
        selected_market: 20,
        selected_provider: 20,
        selected_ride_type: '0',
        selected_activity_period: '1',
        // search_claim_status: '2',
        search_claim_status: 'all',
        min_date: null,
        max_date: null,
        page_sizes: [20, 50, 100, 500, 1000],
        selected_vehicle: null,
        claimsCountsCache: {},
        data: {
          markets: [],
          weeks: [],
          readyToSubmitList: [],
          readyToSubmitManuallyList: [],
          issueList: [],
          plaformFeeOnlyList: [],
          rejectionsList: [],
          deniedList: [],
          unclaimableList: [],
          allTripsList: [],
          submissionsList: [],
          noResponseList: [],
          currentRideVehicles: [],
          currentRideDetail: [],
          bulkSelection: [],
          selected_transaction: null,
          claimsCounts: [],

          filters: {
            status: {
              "unassigned":15,
              "accepted":7,
              "en-route":10,
              "picked-up":11,
              "dropped-off":12,
              "distributing_linear":16,
              "distributing_logarithmic":17,
              "expired":18,
              "canceled":23,
              "canceled_by_rider":2,
              "canceled_by_support":3,
              "rider_no_show":8,
              "driver_no_show":9,
              "paid_denied":24
            }
          },
          resultColumns: [
            {
              "name":"Ride ID",
              "selector": (transaction) => transaction.id_ride.id_ride,
              "routerSelector": (transaction) =>  (transaction.id_ride) ? "/rides/" + transaction.id_ride.id_ride + "/" : null,
              "sort_key": "id_ride"
            },
            {
              "name":"Leg ID",
              "selector": (transaction) => transaction.id_ride.id_alternate,
              "routerSelector": (transaction) =>  (transaction.id_ride) ? "/rides/" + transaction.id_ride.id_ride + "/" : null
            },
            {
              "name":"PU date-time",
              "selector": (transaction) => !transaction.id_ride.pickup_date ? 'N/A' : transaction.id_ride.local_timezone ? moment.utc(transaction.id_ride.pickup_date).tz(transaction.id_ride.local_timezone).format('MM/DD/YY  HH:mm z') : moment.utc(transaction.id_ride.pickup_date).format('MM/DD/YY  HH:mm z'),
              "editable":true,
              "type":"date",
              "api_field_name":"pickup_date",
              "api_type":"geostamp",
              "sort_key":"id_ride__pickup_date",
              "actions": [
                {
                  "name": "Use Default",
                  "action": (transaction) => {
                    // do nothing
                    var r = transaction.id_ride
                    // r.pickup_date = r.date_pickup

                    this.edit_field_value = r.date_pickup
                    this.updateRide(r)

                  }
                },
                {
                  "name": "Use Event Log",
                  "action": (transaction) => {
                    this.showEventLogModel(transaction.id_ride)
                  }
                }
              ]
            },
            {
              "name":"DO date-time",
              // "selector": (ride) => !ride.dropoff_date ? 'N/A' : ride.local_timezone ? moment.utc(ride.dropoff_date).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(ride.dropoff_date).format('MMMM Do YYYY, h:mm:ss a (z)')
              "selector": (transaction) => !transaction.id_ride.dropoff_date ? 'N/A' : transaction.id_ride.local_timezone ? moment.utc(transaction.id_ride.dropoff_date).tz(transaction.id_ride.local_timezone).format('MM/DD/YY  HH:mm z') : moment.utc(transaction.id_ride.dropoff_date).format('MM/DD/YY  HH:mm z'),
              "editable":true,
              "type":"date",
              "api_field_name":"dropoff_date",
              "api_type":"geostamp",
              "sort_key":"id_ride__dropoff_date",
              "actions": [
                {
                  "name": "Use Default",
                  "action": (transaction) => {
                    // do nothing
                    // this.edit_field_value = null
                    var r = transaction.id_ride
                    // moment.utc(ride.date_reservation).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)')



                    // 2020-10-29T17:11:16.444172Z
                    console.log('---')

                    console.log(r.date_pickup)
                    let parsed = moment(r.date_pickup, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
                    console.log(parsed)
                    let duTime = parsed.add(r.default_duration_p_to_d, 'seconds');
                    let duTimeVal = duTime.format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]')
                    // r.dropoff_date = duTimeVal
                    this.edit_field_value = duTimeVal

                    console.log(duTimeVal)
                    console.log('---')
                    this.updateRide(r)


                  }
                },
                {
                  "name": "Use Event Log",
                  "action": (transaction) => {
                    this.showEventLogModel(transaction.id_ride)
                  }
                }
              ]

            },
            {
              "name":"Driver",
              "selector": (transaction) => {
                if (transaction.claims_error && transaction.claims_error.id_driver_set) {
                  return 'Missing ID: ' + ((transaction.id_ride.id_driver) ? transaction.id_ride.id_driver.name_first + ' ' + transaction.id_ride.id_driver.name_last : '')
                } else {
                  return (transaction.id_ride.id_driver) ? transaction.id_ride.id_driver.name_first + ' ' + transaction.id_ride.id_driver.name_last : ''
                }
              },
              "routerSelector": (transaction) =>  (transaction.id_ride.id_driver) ? '/drivers/' + transaction.id_ride.id_driver.id_user + '/' : null,
              "api_field_name":"id_driver_set",
              "sort_key":"id_ride__id_driver__name_first",
            },
            { "name":"Member",
              // "selector": (ride) => (ride.contact_first_name ? ride.contact_first_name : ride.id_rider.name_first) + " " + (ride.contact_last_name ? ride.contact_last_name : ride.id_rider.name_last) ,
              "selector": (transaction) => (transaction.id_ride.id_rider) ? transaction.id_ride.id_rider.name_first + ' ' + transaction.id_ride.id_rider.name_last : null,
              "routerSelector": (transaction) =>  (transaction.id_ride.id_rider) ? "/users/" + transaction.id_ride.id_rider.id_user + "/" : null,
              "sort_key":"id_ride__id_rider__name_first",

            },
            {
              "name":"PU Odom.",
              "selector": (transaction) => !transaction.id_ride.pickup_odometer ? 'N/A' : transaction.id_ride.pickup_odometer,
              "editable":true,
              "type":"number",
              "api_field_name":"pickup_odometer",
              "api_type":"odometer",
              "sort_key":"id_ride__pickup_odometer",
              "actions": [
                {
                  "name": "Use 1, 999",
                  "action": (transaction) => {
                    // do nothing
                    this.edit_field_value = null
                    var r = transaction.id_ride
                    r.pickup_odometer = 1
                    r.dropoff_odometer = 999
                    this.updateRide(r)

                  }
                }
              ]
            },
            {
              "name":"DO Odom.",
              "selector": (transaction) => !transaction.id_ride.dropoff_odometer ? 'N/A' : transaction.id_ride.dropoff_odometer,
              "editable":true,
              "type":"number",
              "api_field_name":"dropoff_odometer",
              "sort_key":"id_ride__dropoff_odometer",
              "api_type":"odometer",
              "actions": [
                {
                  "name": "Use 1, 999",
                  "action": (transaction) => {
                    // do nothing
                    this.edit_field_value = null
                    var r = transaction.id_ride
                    r.pickup_odometer = 1
                    r.dropoff_odometer = 999
                    this.updateRide(r)

                  }
                }
              ]
            },
            {
              "name":"PU Long.",
              "selector": (transaction) => !transaction.id_ride.pickup_longitude ? 'N/A' :transaction.id_ride.pickup_longitude.toFixed(2),
              "api_field_name":"pickup_longitude",
              "editable":true,
              "type":"number",
              "api_type":"pickup_geo",
              "sort_key":"id_ride__pickup_longitude",
              "actions": [
                {
                  "name": "Use Default",
                  "action": (transaction) => {
                    this.edit_field_value = null
                    this.updateRide(transaction.id_ride)
                  }
                },
                {
                  "name": "Use Event Log",
                  "action": (transaction) => {
                    this.showEventLogModel(transaction.id_ride)
                  }
                }
              ]

            },
            {
              "name":"PU Lat.",
              "selector": (transaction) => !transaction.id_ride.pickup_latitude ? 'N/A' :transaction.id_ride.pickup_latitude.toFixed(2),
              "api_field_name":"pickup_latitude",
              "editable":true,
              "type":"number",
              "api_type":"pickup_geo",
              "sort_key":"id_ride__pickup_latitude",
              "actions": [
                  {
                    "name": "Use Default",
                    "action": (transaction) => {
                      this.edit_field_value = null
                      this.updateRide(transaction.id_ride)
                    }
                  },
                  {
                    "name": "Use Event Log",
                    "action": (transaction) => {
                      this.showEventLogModel(transaction.id_ride)
                    }
                  }
                ]
            },
            {
              "name":"DO Long.",
              "selector": (transaction) => !transaction.id_ride.dropoff_longitude ? 'N/A' :transaction.id_ride.dropoff_longitude.toFixed(2),
              "api_field_name":"dropoff_longitude",
              "editable":true,
              "type":"number",
              "api_type":"dropoff_geo",
              "sort_key":"id_ride__dropoff_longitude",
              "actions": [
                  {
                    "name": "Use Default",
                    "action": (transaction) => {
                      // do nothing
                      this.edit_field_value = null
                      this.updateRide(transaction.id_ride)
                    }
                  },
                  {
                    "name": "Use Event Log",
                    "action": (transaction) => {
                      this.showEventLogModel(transaction.id_ride)
                    }
                  }
                ]
            },
            {
              "name":"DO Lat.",
              "selector": (transaction) => !transaction.id_ride.dropoff_latitude ? 'N/A' : transaction.id_ride.dropoff_latitude.toFixed(2),
              "api_field_name":"dropoff_latitude",
              "editable":true,
              "type":"number",
              "api_type":"dropoff_geo",
              "sort_key":"id_ride__dropoff_latitude",
              "actions": [
                  {
                    "name": "Use Default",
                    "action": (transaction) => {
                      // do nothing
                      this.edit_field_value = null
                      this.updateRide(transaction.id_ride)
                    }
                  },
                  {
                    "name": "Use Event Log",
                    "action": (transaction) => {
                      this.showEventLogModel(transaction.id_ride)
                    }
                  }
                ]
            },
            {"name":"Est. Mileage", "selector": (transaction) => transaction.id_ride.default_distance_p_to_d.toFixed(2), "sort_key":"id_ride__default_distance_p_to_d" },
            {"name":"Act. Mileage", "selector": (transaction) => Math.round( transaction.id_ride.dropoff_odometer - transaction.id_ride.pickup_odometer ) },
            {"name":"Est. Duration", "selector": (transaction) => Math.round(transaction.id_ride.default_duration_p_to_d / 60) , "sort_key":"id_ride__default_duration_p_to_d" },
            {
              "name":"Act. Duration",
              "selector": (transaction) => {
                // currently in millis
                if (transaction.id_ride) {
                  return Math.round(( moment.utc(transaction.id_ride.dropoff_date).tz(transaction.id_ride.local_timezone) - moment.utc(transaction.id_ride.pickup_date).tz(transaction.id_ride.local_timezone) ) / 60000)
                } else {
                  return 'N/A'
                }
              }
            },
            {
              "name":"Member Sig",
              "selector": (transaction) => (transaction.claims_error && transaction.claims_error.member_signature) ? 'Missing' : 'Yes' ,
              "api_field_name":"member_signature",
              "sort_key":"id_ride__is_rider_signed",

            },
            {
              "name":"VIN",
              "selector": (transaction) => (transaction.claims_error && transaction.claims_error.vin) ? 'Missing' : transaction.id_ride.id_vehicle.vin.substr(transaction.id_ride.id_vehicle.vin.length - 4) ,
              "api_field_name":"vin",
              "sort_key":"id_ride__id_vehicle__vin",

              "click_action": (transaction) => {
                // do something
                this.showVehicleModel(transaction)
              }
            },
            {"name":"Trip Status",
            "sort_key":"id_ride__id_type_ride_status__code",
            "selector": (transaction) => {
                if (transaction.id_ride.id_type_ride_status.code == 'dropped_off') {
                  return transaction.id_ride.id_type_ride_status.name
                } else {
                  return '<span style="color:red;">' + transaction.id_ride.id_type_ride_status.name + '</span>'
                }
              }
            },
            {
              "name":"Claims Status",
              "selector": (transaction) => (transaction.id_type_claims_status) ? transaction.id_type_claims_status.name : '' ,
              "sort_key": "id_type_claims_status__code"
            },
            {"name":"Rejected Reason", "selector": (transaction) => (transaction.rejected_reason) ? transaction.rejected_reason : (transaction.denial_reason ? transaction.denial_reason : '') },
            {"name":"Submission Count", "selector": (transaction) => (transaction.submission_count) ? transaction.submission_count : 0 },
            {"name":"Claims Deadline", "selector": (transaction) => (transaction.submission_deadline) ? transaction.submission_deadline + ' days' :  '' },
            {"name":"Last updated", "selector": (transaction) => (transaction.last_update_at && transaction.last_update_at != 'N/A') ? moment.utc(transaction.last_update_at).tz(transaction.id_ride.local_timezone).format('MM/DD/YY  HH:mm z')  : 'N/A' },
            {"name":"Action", "selector": (transaction) => transaction.id_ride.id_ride },
            // {"name":"Warnings", "selector": (transaction) => transaction.claims_error },

          ],
          sortDirection: 0,
        },
        isLoading: false,
        currentPage: 1,
        totalRows: 0,
        currentRejectionsPage: 1,
        currentDeniedPage:1,
        currentReadyToSubmitPage: 1,
        currentReadyToSubmitManuallyPage: 1,
        currentAllTripsPage: 1,
        currentSubmissionsPage: 1,
        currentPlatformFeePage: 1,
        currentUnclaimablePage: 1,
        currentNoResponsePage: 1,
        rejectionRows: 0,
        deniedRows: 0,
        unclaimableRows: 0,
        readyToSubmitRows: 0,
        readyToSubmitManuallyRows: 0,
        totalAllTripsRows: 0,
        totalSubmissionRows: 0,
        totalPlatformFeeRows: 0,
        totalNoResponseRows: 0,
        perPage: 20,
        limit: 20,
        errors: null,
        prev_sort: null,

        edit_transaction_id: null,
        edit_field_index: null,
        edit_field_value: null,

        submissionComment: null,
        submissionProductionMode: false,
        manualSubmissionComment: null,
        submissionManualMode: false,
        submissionManualList: [],
        showVehicleSelectModal: false,
        showEventLogSelectModal: false,
        showConfirmSubmissionModal: false,
        showConfirmManualSubmissionModal: false,
        showConfirmAdditionalManualSubmissionModal: false,
        showConfirmNoResponseSubmissionModal: false,
        showColumnFilters: true
      }
    },
    computed: {
      selected_market_name: function () {
        for (var i=0; i < this.data.markets.length; i++) {
          var m = this.data.markets[i]
          if (m.id_market == this.selected_market) {
            return m.name;
          }
        }
        return 'All'
      },
      selected_ride_type_name: function () {
        if (this.selected_ride_type == 0) {
          return 'Regular'
        } else if (this.selected_ride_type == 1) {
          return 'Deadhead'
        } else {
          return 'All'
        }
      },
      selected_activity_period_name: function () {
        for (var i=0; i < this.data.weeks.length; i++) {
          var w = this.data.weeks[i]
          if (w.week == this.selected_activity_period) {
            return moment(w.monday).format('YYYY-MM-DD') +  ' - ' + moment(w.sunday).format('YYYY-MM-DD') ;
          }
        }
        return 'All'
      },
      selected_claim_status_name: function () {
        var cs = parseInt(this.search_claim_status)
        switch (cs) {
          case 1:
            return 'Not provided';
          case 2:
            return 'Ready to submit'
          case 3:
            return 'Warning'
          case 4:
            return 'Submitted'
          case 5:
            return 'Approved'
          case 6:
            return 'Denied'
          case 7:
            return 'Rejected'
          case 8:
            return 'Submitted manually'
          case 9:
            return 'Ready to submit manually'

        }

        return 'All'

      },

    },
    components: {
      Loading
    },
    methods: {
      setEnableEditField: function(transaction, field_index, default_field_value) {

        if (!transaction || !transaction.id_transaction || !field_index) {
          this.edit_transaction_id = null
          this.edit_field_index = null
          this.edit_field_value = null
        } else {
          this.edit_transaction_id = transaction.id_transaction
          this.edit_field_index = field_index
          if (this.data.resultColumns[field_index].type == 'date') {
            this.edit_field_value =  !default_field_value ? '' : transaction.id_ride.local_timezone ? moment.utc(default_field_value).tz(transaction.id_ride.local_timezone).format('MM/DD/YY  HH:mm z') : moment.utc(default_field_value).format('MM/DD/YY  HH:mm z')
          } else {
            this.edit_field_value = (typeof default_field_value == 'number') ? default_field_value.toString() : default_field_value;
          }
        }
      },
      clearAllOption: function() {
        if (this.selected_market && this.selected_market=="all") {
          this.selected_market = 20
        }
        if (this.selected_ride_type && this.selected_ride_type=="all") {
          this.selected_ride_type = 0
        }
      },
      reverseRide: function (ride, transactionId, callback) {
        var sendBack = false
        var type = "cancelFalse";
        if (type == "cancelTrue") {
          sendBack = true
          type = "cancel"
        }
        else if (type == "cancelFalse") {
          type = "cancel"
        }
        this.isLoading = true

        var params = {
          sendBack: sendBack
        }
        this.$http
          .patch(process.env.API_BASE_URL_CS + 'rides/' + ride.id_ride + '/?type=' + type, params)
          .then(response => {
            // this.getRide()
            this.updateClaimStatus(transactionId, 1, callback)
          })
          .catch(error => {
            console.log(error)
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            if (error.response.status == 400) {
              alert(error.response.data[0])
            }
          })
          .finally(() => {
            this.isLoading = false
          })

      },
      updateCurrentTab: function(page, updatedRide) {
        // this.getReadyToSubmitList(page)

        if (updatedRide) {
          var transactions_to_update = []
          // 1) find cached transactions with id
          for (var i=0; i< this.data.readyToSubmitList.length; i++) {
            if (this.data.readyToSubmitList[i].id_ride.id_ride == updatedRide.id_ride) {
              transactions_to_update.push(this.data.readyToSubmitList[i].id_transaction)
            }
          }
          for (var i=0; i< this.data.readyToSubmitManuallyList.length; i++) {
            if (this.data.readyToSubmitManuallyList[i].id_ride.id_ride == updatedRide.id_ride) {
              transactions_to_update.push(this.data.readyToSubmitManuallyList[i].id_transaction)
            }
          }
          for (var i=0; i< this.data.issueList.length; i++) {
            console.log(this.data.issueList[i].id_ride)
            if (this.data.issueList[i].id_ride.id_ride == updatedRide.id_ride) {
              transactions_to_update.push(this.data.issueList[i].id_transaction)
            }
          }
          for (var i=0; i< this.data.rejectionsList.length; i++) {
            console.log(this.data.rejectionsList[i].id_ride)
            if (this.data.rejectionsList[i].id_ride.id_ride == updatedRide.id_ride) {
              transactions_to_update.push(this.data.rejectionsList[i].id_transaction)
            }
          }
          for (var i=0; i< this.data.deniedList.length; i++) {
            console.log(this.data.deniedList[i].id_ride)
            if (this.data.deniedList[i].id_ride.id_ride == updatedRide.id_ride) {
              transactions_to_update.push(this.data.deniedList[i].id_transaction)
            }
          }
          for (var i=0; i< this.data.allTripsList.length; i++) {
            console.log(this.data.allTripsList[i].id_ride)
            if (this.data.allTripsList[i].id_ride.id_ride == updatedRide.id_ride) {
              transactions_to_update.push(this.data.allTripsList[i].id_transaction)
            }
          }
          console.log(transactions_to_update)
          // 2) call refreshTransaction
          for (var i=0; i< transactions_to_update.length; i++) {
            this.refreshTransaction(transactions_to_update[i])
              // update cache
          }
        }
        // this.getIssueList(page)
      },
     refreshTransaction: function (id_transaction) {
        this.$http
          .get(process.env.API_BASE_URL_CS
            + 'transactions/' + id_transaction + '?check_error=1'
          )
          .then(response => {
            console.log(response.data)
            // update cache here
            for (var i=0; i< this.data.readyToSubmitList.length; i++) {
              console.log(this.data.readyToSubmitList[i].id_ride)
              if (this.data.readyToSubmitList[i].id_transaction == response.data.id_transaction) {
                for (var j=0; j< this.data.resultColumns.length; j++) {
                  if (this.data.resultColumns[j].api_field_name) {
                    if (this.data.resultColumns[j].api_field_name == 'vin') {
                      if (response.data.id_ride['id_vehicle'].vin) {
                        this.data.readyToSubmitList[i].id_ride['id_vehicle'] = response.data.id_ride['id_vehicle']
                      }
                    } else {
                      this.data.readyToSubmitList[i].id_ride[this.data.resultColumns[j].api_field_name] = response.data.id_ride[this.data.resultColumns[j].api_field_name]
                    }
                  }
                }
                // claims_error
                this.data.readyToSubmitList[i].claims_error = response.data.claims_error
              }
            }
            for (var i=0; i< this.data.readyToSubmitManuallyList.length; i++) {
              console.log(this.data.readyToSubmitManuallyList[i].id_ride)
              if (this.data.readyToSubmitManuallyList[i].id_transaction == response.data.id_transaction) {
                for (var j=0; j< this.data.resultColumns.length; j++) {
                  if (this.data.resultColumns[j].api_field_name) {
                    if (this.data.resultColumns[j].api_field_name == 'vin') {
                      if (response.data.id_ride['id_vehicle'].vin) {
                        this.data.readyToSubmitManuallyList[i].id_ride['id_vehicle'] = response.data.id_ride['id_vehicle']
                      }
                    } else {
                      this.data.readyToSubmitManuallyList[i].id_ride[this.data.resultColumns[j].api_field_name] = response.data.id_ride[this.data.resultColumns[j].api_field_name]
                    }
                  }
                }
                // claims_error
                this.data.readyToSubmitList[i].claims_error = response.data.claims_error
              }
            }
            for (var i=0; i< this.data.issueList.length; i++) {
              console.log(this.data.issueList[i].id_ride)
              if (this.data.issueList[i].id_transaction == response.data.id_transaction) {
                for (var j=0; j< this.data.resultColumns.length; j++) {
                  if (this.data.resultColumns[j].api_field_name) {
                    if (this.data.resultColumns[j].api_field_name == 'vin') {
                      if (response.data.id_ride['id_vehicle'].vin) {
                        this.data.issueList[i].id_ride['id_vehicle'] = response.data.id_ride['id_vehicle']
                      }
                    } else {
                      this.data.issueList[i].id_ride[this.data.resultColumns[j].api_field_name] = response.data.id_ride[this.data.resultColumns[j].api_field_name]
                    }
                  }
                }
                // claims_error
                this.data.issueList[i].claims_error = response.data.claims_error
              }
            }
            for (var i=0; i< this.data.rejectionsList.length; i++) {
              console.log(this.data.rejectionsList[i].id_ride)
              if (this.data.rejectionsList[i].id_transaction == response.data.id_transaction) {
                for (var j=0; j< this.data.resultColumns.length; j++) {
                  if (this.data.resultColumns[j].api_field_name) {
                    if (this.data.resultColumns[j].api_field_name == 'vin') {
                      if (response.data.id_ride['id_vehicle'].vin) {
                        this.data.rejectionsList[i].id_ride['id_vehicle'] = response.data.id_ride['id_vehicle']
                      }
                    } else {
                      this.data.rejectionsList[i].id_ride[this.data.resultColumns[j].api_field_name] = response.data.id_ride[this.data.resultColumns[j].api_field_name]
                    }
                  }
                }
                // claims_error
                this.data.rejectionsList[i].claims_error = response.data.claims_error
              }
            }
            for (var i=0; i< this.data.deniedList.length; i++) {
              console.log(this.data.deniedList[i].id_ride)
              if (this.data.deniedList[i].id_transaction == response.data.id_transaction) {
                for (var j=0; j< this.data.resultColumns.length; j++) {
                  if (this.data.resultColumns[j].api_field_name) {
                    if (this.data.resultColumns[j].api_field_name == 'vin') {
                      if (response.data.id_ride['id_vehicle'].vin) {
                        this.data.deniedList[i].id_ride['id_vehicle'] = response.data.id_ride['id_vehicle']
                      }
                    } else {
                      this.data.deniedList[i].id_ride[this.data.resultColumns[j].api_field_name] = response.data.id_ride[this.data.resultColumns[j].api_field_name]
                    }
                  }
                }
                // claims_error
                this.data.deniedList[i].claims_error = response.data.claims_error
              }
            }
            for (var i=0; i< this.data.allTripsList.length; i++) {
              console.log(this.data.allTripsList[i].id_ride)
              if (this.data.allTripsList[i].id_transaction == response.data.id_transaction) {
                for (var j=0; j< this.data.resultColumns.length; j++) {
                  if (this.data.resultColumns[j].api_field_name) {
                    if (this.data.resultColumns[j].api_field_name == 'vin') {
                      if (response.data.id_ride['id_vehicle'].vin) {
                        this.data.allTripsList[i].id_ride['id_vehicle'] = response.data.id_ride['id_vehicle']
                      }
                    } else {
                      this.data.allTripsList[i].id_ride[this.data.resultColumns[j].api_field_name] = response.data.id_ride[this.data.resultColumns[j].api_field_name]
                    }
                  }
                }
                // claims_error
                this.data.allTripsList[i].claims_error = response.data.claims_error
              }
            }
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
      },
      getReadyToSubmitList: function (page) {
        if (this.selected_provider && this.selected_provider == 'deadhead') {
          this.selected_market = 20
          this.selected_ride_type = 1
        } else {
          this.selected_market = this.selected_provider
          this.selected_ride_type = 0
        }

        this.isLoading = true
        this.uncheckAll()
        this.$http
          .get(process.env.API_BASE_URL_CS
            + 'transactions/?type=weekly_claims&check_error=1&id_type_claims_status=2'
            + (this.selected_activity_period == null || this.selected_activity_period == 'all' ? '' : '&week=' + this.selected_activity_period)
            + (this.selected_market == "all" ? '' : '&id_market=' + this.selected_market)
            + '&deadhead=' + this.selected_ride_type


            + (this.current_ride_status == null ? '' : '&id_type_ride_status=' + this.current_ride_status)
            + (this.min_date == null ? '' : '&date_pickup__gte=' + this.min_date)
            + (this.max_date == null ? '' : '&date_pickup__lte=' + this.max_date)
            + '&ordering=' + (this.prev_sort ? (this.prev_sort.getAttribute('value')>0 ? '' : '-') + this.prev_sort.getAttribute('name') : '')
            // + '&page=1'
            + '&page=' + (page ? page : this.currentReadyToSubmitPage)
            + '&page_size=' + (this.perPage)
            , { timeout: 120000 }
          )
          .then(response => {
            this.data.readyToSubmitList = response.data.results.slice(0)
            console.log(response.data.results)
            if (response.data && response.data.count >= 0) {
              this.readyToSubmitRows = response.data.count
            }



          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      getReadyToSubmitManuallyList: function (page) {
        if (this.selected_provider && this.selected_provider == 'deadhead') {
          this.selected_market = 20
          this.selected_ride_type = 1
        } else {
          this.selected_market = this.selected_provider
          this.selected_ride_type = 0
        }

        this.isLoading = true
        this.uncheckAll()
        this.$http
          .get(process.env.API_BASE_URL_CS
            + 'transactions/?type=weekly_claims&check_error=1&id_type_claims_status=9'
            + (this.selected_activity_period == null || this.selected_activity_period == 'all' ? '' : '&week=' + this.selected_activity_period)
            + (this.selected_market == "all" ? '' : '&id_market=' + this.selected_market)
            + '&deadhead=' + this.selected_ride_type
            + (this.current_ride_status == null ? '' : '&id_type_ride_status=' + this.current_ride_status)
            + (this.min_date == null ? '' : '&date_pickup__gte=' + this.min_date)
            + (this.max_date == null ? '' : '&date_pickup__lte=' + this.max_date)
            + '&ordering=' + (this.prev_sort ? (this.prev_sort.getAttribute('value')>0 ? '' : '-') + this.prev_sort.getAttribute('name') : '')
            // + '&page=1'
            + '&page=' + (page ? page : this.currentReadyToSubmitManuallyPage)
            + '&page_size=' + (this.perPage)
            , { timeout: 120000 }
          )
          .then(response => {
            this.data.readyToSubmitManuallyList = response.data.results.slice(0)
            console.log(response.data.results)
            if (response.data && response.data.count >= 0) {
              this.readyToSubmitManuallyRows = response.data.count
            }



          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      getIssueList: function (page) {
        if (this.selected_provider && this.selected_provider == 'deadhead') {
          this.selected_market = 20
          this.selected_ride_type = 1
        } else {
          this.selected_market = this.selected_provider
          this.selected_ride_type = 0
        }

        this.isLoading = true
        this.uncheckAll()
        this.$http
          .get(process.env.API_BASE_URL_CS
            + 'transactions/?type=weekly_claims&check_error=1&id_type_claims_status=3'
            + (this.selected_activity_period == null || this.selected_activity_period == 'all'  ? '' : '&week=' + this.selected_activity_period)
            + (this.selected_market == null || this.selected_market == "all" ? '' : '&id_market=' + this.selected_market)
            + (this.selected_ride_type == null || this.selected_ride_type == "all" ? '' : '&deadhead=' + this.selected_ride_type)
            + (this.current_ride_status == null ? '' : '&id_type_ride_status=' + this.current_ride_status)
            + (this.min_date == null ? '' : '&date_pickup__gte=' + this.min_date)
            + (this.max_date == null ? '' : '&date_pickup__lte=' + this.max_date)
            + '&ordering=' + (this.prev_sort ? (this.prev_sort.getAttribute('value')>0 ? '' : '-') + this.prev_sort.getAttribute('name') : '')
            + '&page=' + (page ? page : this.currentPage)
            + '&page_size=' + (this.perPage)
          )
          .then(response => {
            this.data.issueList = response.data.results.slice(0)

            if (response.data && response.data.count >= 0) {
              this.totalRows = response.data.count
            }

            $('.transaction-edit-cell .dropdown-menu').on("click.bs.dropdown", function (e) {
                if ($(e.target).hasClass('close-dropdown-link')) {

                } else {
                  e.stopPropagation();
                  e.preventDefault();

                }

              });

          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      getDeniedList: function (page) {
        if (this.selected_provider && this.selected_provider == 'deadhead') {
          this.selected_market = 20
          this.selected_ride_type = 1
        } else {
          this.selected_market = this.selected_provider
          this.selected_ride_type = 0
        }

        this.isLoading = true
        this.uncheckAll()
        this.$http
          .get(process.env.API_BASE_URL_CS
            + 'transactions/?type=weekly_claims&check_error=1&id_type_claims_status=6'
            + (this.selected_activity_period == null || this.selected_activity_period == 'all'  ? '' : '&week=' + this.selected_activity_period)
            + (this.selected_market == null || this.selected_market == "all" ? '' : '&id_market=' + this.selected_market)
            + (this.selected_ride_type == null || this.selected_ride_type == "all" ? '' : '&deadhead=' + this.selected_ride_type)
            + (this.current_ride_status == null ? '' : '&id_type_ride_status=' + this.current_ride_status)
            + (this.min_date == null ? '' : '&date_pickup__gte=' + this.min_date)
            + (this.max_date == null ? '' : '&date_pickup__lte=' + this.max_date)
            + '&ordering=' + (this.prev_sort ? (this.prev_sort.getAttribute('value')>0 ? '' : '-') + this.prev_sort.getAttribute('name') : '')
            + '&page=' + (page ? page : this.currentDeniedPage)
            + '&page_size=' + (this.perPage)
          )
          .then(response => {
            this.data.deniedList = response.data.results.slice(0)

            if (response.data && response.data.count >= 0) {
              this.deniedRows = response.data.count
            }

            $('.transaction-edit-cell .dropdown-menu').on("click.bs.dropdown", function (e) {
                if ($(e.target).hasClass('close-dropdown-link')) {

                } else {
                  e.stopPropagation();
                  e.preventDefault();

                }

              });

          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      getUnclaimableList: function (page) {
        if (this.selected_provider && this.selected_provider == 'deadhead') {
          this.selected_market = 20
          this.selected_ride_type = 1
        } else {
          this.selected_market = this.selected_provider
          this.selected_ride_type = 0
        }

        this.isLoading = true
        this.uncheckAll()
        this.$http
          .get(process.env.API_BASE_URL_CS
            + 'transactions/?type=weekly_claims&check_error=1&id_type_claims_status=10'
            + (this.selected_activity_period == null || this.selected_activity_period == 'all'  ? '' : '&week=' + this.selected_activity_period)
            + (this.selected_market == null || this.selected_market == "all" ? '' : '&id_market=' + this.selected_market)
            + (this.selected_ride_type == null || this.selected_ride_type == "all" ? '' : '&deadhead=' + this.selected_ride_type)
            + (this.current_ride_status == null ? '' : '&id_type_ride_status=' + this.current_ride_status)
            + (this.min_date == null ? '' : '&date_pickup__gte=' + this.min_date)
            + (this.max_date == null ? '' : '&date_pickup__lte=' + this.max_date)
            + '&ordering=' + (this.prev_sort ? (this.prev_sort.getAttribute('value')>0 ? '' : '-') + this.prev_sort.getAttribute('name') : '')
            + '&page=' + (page ? page : this.currentDeniedPage)
            + '&page_size=' + (this.perPage)
          )
          .then(response => {
            this.data.unclaimableList = response.data.results.slice(0)

            if (response.data && response.data.count >= 0) {
              this.unclaimableRows = response.data.count
            }

            $('.transaction-edit-cell .dropdown-menu').on("click.bs.dropdown", function (e) {
                if ($(e.target).hasClass('close-dropdown-link')) {

                } else {
                  e.stopPropagation();
                  e.preventDefault();

                }

              });

          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      getRejectionsList: function (page) {
        if (this.selected_provider && this.selected_provider == 'deadhead') {
          this.selected_market = 20
          this.selected_ride_type = 1
        } else {
          this.selected_market = this.selected_provider
          this.selected_ride_type = 0
        }

        this.isLoading = true
        this.uncheckAll()
        this.$http
          .get(process.env.API_BASE_URL_CS
            + 'transactions/?type=weekly_claims&check_error=1&id_type_claims_status=7'
            + (this.selected_activity_period == null || this.selected_activity_period == 'all'  ? '' : '&week=' + this.selected_activity_period)
            + (this.selected_market == null || this.selected_market == "all" ? '' : '&id_market=' + this.selected_market)
            + (this.selected_ride_type == null || this.selected_ride_type == "all" ? '' : '&deadhead=' + this.selected_ride_type)
            + (this.current_ride_status == null ? '' : '&id_type_ride_status=' + this.current_ride_status)
            + (this.min_date == null ? '' : '&date_pickup__gte=' + this.min_date)
            + (this.max_date == null ? '' : '&date_pickup__lte=' + this.max_date)
            + '&ordering=' + (this.prev_sort ? (this.prev_sort.getAttribute('value')>0 ? '' : '-') + this.prev_sort.getAttribute('name') : '')
            + '&page=' + (page ? page : this.currentRejectionsPage)
            + '&page_size=' + (this.perPage)
          )
          .then(response => {
            this.data.rejectionsList = response.data.results.slice(0)

            if (response.data && response.data.count >= 0) {
              this.rejectionRows = response.data.count
            }

            $('.transaction-edit-cell .dropdown-menu').on("click.bs.dropdown", function (e) {
                if ($(e.target).hasClass('close-dropdown-link')) {

                } else {
                  e.stopPropagation();
                  e.preventDefault();

                }

              });

          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      getAllTripsList: function (page) {
        if (this.selected_provider && this.selected_provider == 'deadhead') {
          this.selected_market = 20
          this.selected_ride_type = 1
        } else {
          this.selected_market = this.selected_provider
          this.selected_ride_type = 0
        }

        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS
            + 'transactions/?type=weekly_claims&check_error=1'
            + (this.search_claim_status == null || this.search_claim_status == 'all'  ? '' : '&id_type_claims_status=' + this.search_claim_status)
            + (this.selected_activity_period == null || this.selected_activity_period == 'all'  ? '' : '&week=' + this.selected_activity_period)
            + (this.selected_market == null || this.selected_market == "all" ? '' : '&id_market=' + this.selected_market)
            + (this.selected_ride_type == null || this.selected_ride_type == "all" ? '' : '&deadhead=' + this.selected_ride_type)
            + (this.current_ride_status == null ? '' : '&id_type_ride_status=' + this.current_ride_status)
            + (this.min_date == null ? '' : '&date_pickup__gte=' + this.min_date)
            + (this.max_date == null ? '' : '&date_pickup__lte=' + this.max_date)
            + '&ordering=' + (this.prev_sort ? (this.prev_sort.getAttribute('value')>0 ? '' : '-') + this.prev_sort.getAttribute('name') : '')
            + '&page=' + (page ? page : this.currentPage)
            + '&page_size=' + (this.perPage)
          )
          .then(response => {
            this.data.allTripsList = response.data.results.slice(0)

            if (response.data && response.data.count >= 0) {
              this.totalAllTripsRows = response.data.count
            }

            $('.transaction-edit-cell .dropdown-menu').on("click.bs.dropdown", function (e) {
                if ($(e.target).hasClass('close-dropdown-link')) {

                } else {
                  e.stopPropagation();
                  e.preventDefault();

                }

              });

          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      getSubmissions: function (page) {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS
            + 'claims-submission/?'
            + 'page=' + (page ? page : this.currentPage)
            + '&page_size=' + (this.perPage)
          )
          .then(response => {
            this.data.submissionsList = response.data.slice(0).reverse()

            if (response.data && response.data.count >= 0) {
              this.totalSubmissionRows = response.data.length
            }
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      getPlatformFeeOnlyRides: function (page) {
        if (this.selected_provider && this.selected_provider == 'deadhead') {
          this.selected_market = 20
          this.selected_ride_type = 1
        } else {
          this.selected_market = this.selected_provider
          this.selected_ride_type = 0
        }

        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS
            + 'transactions/?type=additional_payments'
            + (this.search_claim_status == null || this.search_claim_status == 'all'  ? '' : '&id_type_claims_status=' + this.search_claim_status)
            + (this.selected_activity_period == null || this.selected_activity_period == 'all'  ? '' : '&week=' + this.selected_activity_period)
            + (this.selected_market == "All" ? '' : '&id_market=' + this.selected_market)
            + '&deadhead=' + this.selected_ride_type
            + '&page=' + (page ? page : this.currentPage)
            + '&page_size=' + (this.perPage)
          )
          .then(response => {
            this.data.plaformFeeOnlyList = response.data.results.slice(0)
            if (response.data && response.data.count >= 0) {
              this.totalPlatformFeeRows = response.data.count
            }

          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      getNoResponseList: function (page) {
        if (this.selected_provider && this.selected_provider == 'deadhead') {
          this.selected_market = 20
          this.selected_ride_type = 1
        } else {
          this.selected_market = this.selected_provider
          this.selected_ride_type = 0
        }

        this.isLoading = true
        this.uncheckAll()
        this.$http
          .get(process.env.API_BASE_URL_CS
            + 'rides/?type=old_dropoff'
            // + (this.selected_activity_period == null || this.selected_activity_period == 'all' ? '' : '&week=' + this.selected_activity_period)
            + (this.selected_market == "all" ? '' : '&id_market=' + this.selected_market)
            + (this.selected_ride_type == null || this.selected_ride_type == "all" ? '' : '&deadhead=' + this.selected_ride_type)
            // + '&ordering=' + (this.prev_sort ? (this.prev_sort.getAttribute('value')>0 ? '' : '-') + this.prev_sort.getAttribute('name') : '')
            + '&page=' + (page ? page : this.currentNoResponsePage)
            + '&page_size=' + (this.perPage)
            , { timeout: 120000 }
          )
          .then(response => {
            this.data.noResponseList = response.data.results.slice(0)
            console.log(response.data.results)
            if (response.data && response.data.count >= 0) {
              this.totalNoResponseRows = response.data.count
            }



          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      getClaimsCounts: function () {
        this.isLoading = true
        this.uncheckAll()
        this.$http
          .get(process.env.API_BASE_URL_CS
            + 'transactions/count-statuses/?week=0'
            , { timeout: 120000 }
          )
          .then(response => {

            // filter null statuses
            var filteredCounts = []
            var precache = {};

            for (var i=0; i<response.data.length; i++) {
              if (response.data[i][2] != null) {
                filteredCounts.push(response.data[i])

                var marketCacheKey = (response.data[i][0]) ? response.data[i][0] : 'null'
                var payPeriodCacheKey = (response.data[i][1]) ? response.data[i][1] : 'null'
                var statusCacheKey = (response.data[i][2]) ? response.data[i][2] : 'null'
                var cacheKey = 'null' + ':::' + payPeriodCacheKey + ':::' + statusCacheKey
                if (!precache[cacheKey]) {
                  precache[cacheKey] = 0
                }
                precache[cacheKey] += response.data[i][3]

                cacheKey = 'null' + ':::' + payPeriodCacheKey + ':::' + 'null'
                if (!precache[cacheKey]) {
                  precache[cacheKey] = 0
                }
                precache[cacheKey] += response.data[i][3]

                cacheKey = marketCacheKey + ':::' + 'null' + ':::' + 'null'
                if (!precache[cacheKey]) {
                  precache[cacheKey] = 0
                }
                precache[cacheKey] += response.data[i][3]

                cacheKey = marketCacheKey + ':::' + 'null' + ':::' + statusCacheKey
                if (!precache[cacheKey]) {
                  precache[cacheKey] = 0
                }
                precache[cacheKey] += response.data[i][3]

                cacheKey = 'null' + ':::' + 'null' + ':::' + statusCacheKey
                if (!precache[cacheKey]) {
                  precache[cacheKey] = 0
                }
                precache[cacheKey] += response.data[i][3]

                cacheKey = 'null' + ':::' + 'null' + ':::' + 'null'
                if (!precache[cacheKey]) {
                  precache[cacheKey] = 0
                }
                precache[cacheKey] += response.data[i][3]

              }

            }

            this.data.claimsCounts = filteredCounts
            this.claimsCountsCache = precache
          })
          .catch(error => {
            console.log(error)
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      getClaimsCount: function (market, payperiod, status) {
        var count = 0;
        var marketCacheKey = (market) ? market : 'null'
        var payPeriodCacheKey = (payperiod) ? payperiod : 'null'
        var statusCacheKey = (status) ? status : 'null'
        var cacheKey = marketCacheKey + ':::' + payPeriodCacheKey + ':::' + statusCacheKey

        if (!this.claimsCountsCache) {
          console.log('initializing claims count cache')
          this.claimsCountsCache = {}
        }

        if (typeof this.claimsCountsCache[cacheKey] !== 'undefined') {
          //console.log('claimscount hit ' + cacheKey)
          return this.claimsCountsCache[cacheKey]
        } else {
          // for (var i=0; i<this.data.claimsCounts.length; i++) {
          //   if ((!market || market == this.data.claimsCounts[i][0]) &&
          //       (!payperiod || payperiod == this.data.claimsCounts[i][1]) &&
          //       (!status || status == this.data.claimsCounts[i][2])) {
          //     count += this.data.claimsCounts[i][3]
          //   }

          // }
          // this.claimsCountsCache[cacheKey] = count
          // if (count != 0) {
          //   console.log('claimscount miss ' + cacheKey + ' ' + this.claimsCountsCache[cacheKey])

          // }

        }


        return count;
      },
      updateClaimStatus: function(id , claimStatusId, callback) {
          this.isLoading = true
          let params = {"id_type_claims_status": claimStatusId}

          this.$http
          .patch(process.env.API_BASE_URL_CS + 'transactions/' + id + "/?type=change_claims_status", params)
          .then(response => {

          })
          .catch(error => {
            this.check403(error);
            if (error.response != null && error.response.status != null && error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
          .finally(() => {
            // this.getReadyToSubmitList()
            // this.getIssueList()
            this.getClaimsCounts()
            if (callback) {
              callback()
            }
          })
      },
      bulkUpdateStatus: function (claimStatus, callback) {
          this.isLoading = true
          let params = {"id_type_claims_status": claimStatus}

          if (this.data.bulkSelection && this.data.bulkSelection.length > 0) {

            let id = this.data.bulkSelection.pop()

            console.log(id)

            this.$http
            .patch(process.env.API_BASE_URL_CS + 'transactions/' + id + "/?type=change_claims_status", params)
            .then(response => {
              console.log('done ' + id)

            })
            .catch(error => {
              this.check403(error);
              if (error.response != null && error.response.status != null && error.response.status == 401) {
                console.warn("redirect to login")
                this.handle401()
              }
              console.log(error.response)
              this.errors = error.response.data
              this.non_field_errors = error.response.data.non_field_errors
            })
            .finally(() => {
              this.bulkUpdateStatus(claimStatus, callback)

            })


          } else {
            this.getClaimsCounts()
            if (callback) {
              callback()
            }
          }
      },
      checkAll: function(listToCheck) {
        this.data.bulkSelection = []
        for (var t in listToCheck) {
          this.data.bulkSelection.push(listToCheck[t].id_transaction)
        }
        console.log(this.data.bulkSelection)
      },
      uncheckAll: function() {
        this.data.bulkSelection = []
      },
      sort(field, callback) {
        console.log(field)

        let obj = this.$refs[field]
        if(Array.isArray(obj) && obj.length > 0) {
          obj = obj[0]
        }
        console.log(obj)

        if (this.prev_sort) {
          this.prev_sort.style.visibility = 'hidden'
        }

        let value = obj.getAttribute('value')
        console.log(obj.getAttribute('name'))
        obj.setAttribute('value', -value)
        console.log(obj.getAttribute('value'))

        obj.style.visibility = 'visible'
        obj.style.transform = "rotate("  + (value>0?0:1) * 180 +  "deg)"

        this.prev_sort = obj

        callback()
      },
      updateRide: function (ride) {

        this.isLoading = true


        var field_info = this.data.resultColumns[this.edit_field_index]
        var api_type = field_info.api_type
        var api_field_name = field_info.api_field_name

        if (field_info && api_field_name && api_type ) {

          var params = {
            instructions: ride.instructions,
            date_pickup: ride.date_pickup,
            // date_dropoff: ride.date_dropoff,

            pickup_odometer: ride.pickup_odometer?ride.pickup_odometer:0,
            dropoff_odometer: ride.dropoff_odometer?ride.dropoff_odometer:0,

            // pickup_latitude: ride.pickup_latitude,
            // pickup_longitude: ride.pickup_longitude,
            // dropoff_latitude: ride.dropoff_latitude,
            // dropoff_longitude: ride.dropoff_longitude,

            id_alternate: ride.id_alternate,
            // sendBack: sendBack
          }
          if (this.edit_field_value != null) {
            if (ride.pickup_latitude) {
              params.pickup_latitude = ride.pickup_latitude.toFixed(7);
            }
            if (ride.pickup_longitude) {
              params.pickup_longitude = ride.pickup_longitude.toFixed(7);
            }
            if (ride.dropoff_latitude) {
              params.dropoff_latitude = ride.dropoff_latitude.toFixed(7);
            }
            if (ride.dropoff_longitude) {
              params.dropoff_longitude = ride.dropoff_longitude.toFixed(7);
            }

            try {
              if (field_info.type == 'date' && moment(this.edit_field_value, 'MM/DD/YY  HH:mm z').isValid()) {
                this.edit_field_value = moment.utc(new Date(this.edit_field_value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]')
              }
            } catch (e) {
              console.log(e)
            }

            if (api_field_name != 'pickup_latitude' && api_field_name != 'pickup_longitude' && api_field_name != 'dropoff_latitude' && api_field_name != 'dropoff_longitude') {
              params[api_field_name] = (field_info && field_info.type && field_info.type == 'number') ? parseInt(this.edit_field_value) : this.edit_field_value
            }
          }

          this.$http
            .patch(process.env.API_BASE_URL_CS + 'rides/' + ride.id_ride + '/?type=' + api_type, params)
            .then(response => {
              this.setEnableEditField( null, null )
              this.updateCurrentTab(null, ride)
            })
            .catch(error => {
              console.log(error)
              this.check403(error);
              if (error.response && error.response.status == 401) {
                console.warn("redirect to login")
                this.handle401()
              }
              if (error.response && error.response.status == 400) {
                alert(error.response.data[0])
              }
            })
            .finally(() => {

              this.isLoading = false


            })
        }

      },
      updateRideFromEventLog: function (ride, event) {
        var field_info = this.data.resultColumns[this.edit_field_index]
        var api_type = field_info.api_type
        var api_field_name = field_info.api_field_name

        if (api_field_name == 'pickup_date' || api_field_name == 'dropoff_date' ) {
          this.edit_field_value = event.created_at
        }
        if (api_field_name == 'pickup_latitude' || api_field_name == 'pickup_longitude') {
          var latlng = this.getLatLngFromComment(event.description)
          console.log(latlng)
          ride.pickup_latitude = latlng.lat
          ride.pickup_longitude = latlng.lng
          this.edit_field_value = ride[api_field_name].toString();
        }
        if (api_field_name == 'dropoff_latitude' || api_field_name == 'dropoff_longitude' ) {
          this.edit_field_value = ""
          var latlng = this.getLatLngFromComment(event.description)
          ride.dropoff_latitude = latlng.lat
          ride.dropoff_longitude = latlng.lng
          this.edit_field_value = ride[api_field_name].toString();

        }
        this.updateRide(ride)
        this.showEventLogSelectModal = false
      },
      currentButtonSearch(page) {
        this.resetPager()
        this.getIssueList(page)
      },
      getMarkets: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'markets/')
          .then(response => {
            this.data.markets = response.data
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
      },
     getPayPeriods: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'transactions/weeks/')
          .then(response => {
            this.data.weeks = response.data
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
      },
     validateClaims: function ( currentList, callback) {
        this.isLoading = true
        var ids = []
        if (currentList) {
          for (var i=0; i<currentList.length; i++) {
            ids.push(currentList[i].id_transaction)
          }
        } else {
          if (this.data.bulkSelection && this.data.bulkSelection.length > 0) {
            for (var i=0; i<this.data.bulkSelection.length; i++) {
              ids.push(this.data.bulkSelection[i])
            }
          }
        }
        this.uncheckAll();
        var params = {
          ids: ids
        }

        console.log(params)

        this.$http
          .post(process.env.API_BASE_URL_CS + 'check-set-claims-status/', params)
          .then(response => {
            if (callback) {
              callback()
            }
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          }).finally(() => this.isLoading = false)
      },
      resetClaimsStatus: function(page) {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS
            + 'transactions/?type=weekly_claims&check_error=1'
            + (this.search_claim_status == null || this.search_claim_status == 'all'  ? '' : '&id_type_claims_status=' + this.search_claim_status)
            + (this.selected_activity_period == null || this.selected_activity_period == 'all'  ? '' : '&week=' + this.selected_activity_period)
            + (this.selected_market == "All" ? '' : '&id_market=' + this.selected_market)
            + (this.current_ride_status == null ? '' : '&id_type_ride_status=' + this.current_ride_status)
            + '&validate_claims=1'
            + '&page=' + (page ? page : this.currentPage)
            + '&page_size=' + (this.perPage)
          )
          .then(response => {
            this.data.allTripsList = response.data.results.slice(0)

            if (response.data && response.data.count >= 0) {
              this.totalAllTripsRows = response.data.count
            }

            $('.transaction-edit-cell .dropdown-menu').on("click.bs.dropdown", function (e) {
                if ($(e.target).hasClass('close-dropdown-link')) {

                } else {
                  e.stopPropagation();
                  e.preventDefault();

                }

              });

          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      generate_manual_submission: function (submitList) {
        this.isLoading = true
        var ids = []
        for (var i=0; i<submitList.length; i++) {
          ids.push(submitList[i].id_transaction)
        }


        var params = {
          ids: ids,
          notes: this.manualSubmissionComment,
          update_status: this.submissionManualMode ? 1 : 0
        }

        this.$http
          .post(process.env.API_BASE_URL_CS + 'download-manual-submission-file/', params)
          .then(response => {
            if (response.data.url) {
              var link = document.createElement("a");
              link.download = 'claims-submission';
              link.href = response.data.url;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              // delete link;

              // test me
              this.manualSubmissionComment = null
              this.submissionManualMode = false
              // refresh list
              this.getReadyToSubmitManuallyList()
            }

          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          }).finally(() => this.isLoading = false)
      },
      generate_platform_fee_manual_submission: function () {
        this.isLoading = true
        var ids = []

        if (this.data.bulkSelection && this.data.bulkSelection.length > 0) {
          for (var i=0; i<this.data.bulkSelection.length; i++) {
            ids.push(this.data.bulkSelection[i])
          }
        } else {
          for (var i=0; i<this.data.plaformFeeOnlyList.length; i++) {
            ids.push(this.data.plaformFeeOnlyList[i].id_transaction)
          }
        }


        var params = {
          ids: ids,
          notes: this.manualSubmissionComment,
          update_status: this.submissionManualMode ? 1 : 0,
          type:'additional_payments'
        }

        this.$http
          .post(process.env.API_BASE_URL_CS + 'download-manual-submission-file/', params)
          .then(response => {
            if (response.data.url) {
              var link = document.createElement("a");
              link.download = 'claims-submission';
              link.href = response.data.url;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              // delete link;
            }

          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          }).finally(() => this.isLoading = false)
      },
      generate_no_response_manual_submission: function () {
        this.isLoading = true
        var ids = []
        console.log(this.data.noResponseList)
        for (var i=0; i<this.data.noResponseList.length; i++) {
          console.log(this.data.noResponseList[i])
          if (this.data.noResponseList[i].claims && this.data.noResponseList[i].claims.id_transaction) {
            ids.push(this.data.noResponseList[i].claims.id_transaction)
          }
        }
        var params = {
          ids: ids,
          notes: this.manualSubmissionComment,
          update_status: this.submissionManualMode ? 1 : 0,
          type:'old_dropoffs'
        }

        this.$http
          .post(process.env.API_BASE_URL_CS + 'download-manual-submission-file/', params)
          .then(response => {
            if (response.data.url) {
              var link = document.createElement("a");
              link.download = 'claims-submission';
              link.href = response.data.url;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              // delete link;
            }

          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          }).finally(() => this.isLoading = false)
      },
      submitClaims: function () {
        this.isLoading = true
        var ids = []
        for (var i=0; i<this.data.readyToSubmitList.length; i++) {
          ids.push(this.data.readyToSubmitList[i].id_transaction)
        }


        var params = {
          ids: ids,
          comment: this.submissionComment
        }

        console.log(params)
        console.log(this.submissionProductionMode)



        this.$http
          .post(process.env.API_BASE_URL_CS + 'submit-claims/' + (this.submissionProductionMode ? "?production_mode=1": ""), params)
          .then(response => {

              this.submissionComment = null;
              this.submissionProductionMode = false;
              this.getReadyToSubmitList()

          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          }).finally(() => this.isLoading = false)
      },
      showVehicleModel: function (transaction) {
        this.isLoading = true
        let ride = transaction.id_ride
        this.$http
          .get(process.env.API_BASE_URL_CS
            + 'vehicles/?id_driver=' + ride.id_driver.id_user
          )
          .then(response => {
            this.data.selected_transaction = transaction;
            this.data.currentRideVehicles = response.data.results.slice(0)
            this.showVehicleSelectModal = true;
            this.selected_vehicle = (ride.id_vehicle) ? ride.id_vehicle.id_vehicle : '';

          })
          .catch(error => {
            // this.check403(error);
            // if (error.response.status == 401) {
            //   console.warn("redirect to login")
            //   this.handle401()
            // }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      updateVehicle: function () {
        this.isLoading = true
        let params = {"id_vehicle": this.selected_vehicle}
        console.error(params)
        this.$http
          .patch(process.env.API_BASE_URL_CS + 'rides/' + this.data.selected_transaction.id_ride.id_ride + '/?type=update_vehicle', params)
          .then(response => {
            this.refreshTransaction(this.data.selected_transaction.id_transaction)
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      syncSubmissionRejections: function (submissionId) {
        this.isLoading = true
        let params = {}
        console.error(params)
        this.$http
          .patch(process.env.API_BASE_URL_CS + 'claims-submission/' + submissionId + '/?type=check_ftp_status', params)
          .then(response => {
              this.getSubmissions()
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      syncSubmissionSETStatus: function (submissionId) {
        this.isLoading = true
        let params = {}
        console.error(params)
        this.$http
          .patch(process.env.API_BASE_URL_CS + 'claims-submission/' + submissionId + '/?type=check_set_status', params)
          .then(response => {
              this.getSubmissions()
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      showEventLogModel: function (ride, type, field) {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS
            + 'rides/' + ride.id_ride + '/'
          )
          .then(response => {
            this.data.currentRideDetail = response.data
            this.showEventLogSelectModal = true;

          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      getLatLngFromComment: function(str) {

        const regexs = [
          /^Updated pickup lat\/lng to ([+-]?\d+\.?\d*|\.\d+), ([+-]?\d+\.?\d*|\.\d+)$/, // Updated pickup lat/lng to 33.6813664, -84.0000000
          /^Updated dropoff lat\/lng to ([+-]?\d+\.?\d*|\.\d+), ([+-]?\d+\.?\d*|\.\d+)$/, // Updated dropoff lat/lng to 33.967335, -84.260515
          /^\[([+-]?\d+\.?\d*|\.\d+), ([+-]?\d+\.?\d*|\.\d+)\]$/, // [34.02750812842049, -84.42786742597833]
          /Invalid ride state: picked_up. \[([+-]?\d+\.?\d*|\.\d+), ([+-]?\d+\.?\d*|\.\d+)\]$/, //Invalid ride state: picked_up.
          /Invalid ride state: dropped_off. \[([+-]?\d+\.?\d*|\.\d+), ([+-]?\d+\.?\d*|\.\d+)\]$/, //Invalid ride state: dropped_off.
          /Invalid ride state: en_route. \[([+-]?\d+\.?\d*|\.\d+), ([+-]?\d+\.?\d*|\.\d+)\]$/ //Invalid ride state: en_route.


        ]
        for (var i=0; i<regexs.length; i++) {
          if (str) {
            console.log(str)
            console.log('asdasdad ' + regexs[i])

            var j = str.match(regexs[i])
            console.log(j)
            if (j) console.log(j.length)

            if (j && j.length > 2) {
              return {
                lat: parseFloat(j[1]),
                lng: parseFloat(j[2])
              }
            }

          }
        }
        return null;
      },
      replaceURLWithHTMLLinks: function(text) {
          var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/i;
          return text.replace(exp,"<a href='$1' target='_blank'>$1</a>");
      },
      changePage: function (page) {
        this.getIssueList(page)
      },
      changeReadyToSubmitPage: function (page) {
        this.getReadyToSubmitList(page)
      },
      changeReadyToSubmitManuallyPage: function (page) {
        this.getReadyToSubmitManuallyList(page)
      },
      changeAllTripsPage: function (page) {
        this.getAllTripsList(page)
      },

      changeDeniedTripsPage: function (page) {
        this.getDeniedList(page)
      },
      changeUnclaimableTripsPage: function (page) {
        this.getUnclaimableList(page)
      },
      changeRejectedTripsPage: function (page) {
        this.getRejectionsList(page)
      },
      changeSubmissionsPage: function (page) {
        this.getSubmissions(page)
      },
      changePlatformFeePage: function (page) {
        this.getPlatformFeeOnlyRides(page)
      },
      changeNoResponsePage: function (page) {
        this.getNoResponseList(page)
      },
      checkPageSize: function(event) {
        this.getReadyToSubmitList()
      },
      resetPager: function () {
        this.currentPage = 1
        this.totalRows = 0
      },
      clearDate(date) {
        if (date == 'min_date') {
          this.min_date = null
        }
        if (date == 'max_date') {
          this.max_date = null
        }
      },
      clearFilters: function (callback) {
        this.selected_market = 20;
        this.selected_ride_type = 0;
        this.perPage = 20;
        this.selected_activity_period = 'all'
        callback()
      },
      hasFilters: function() {
        return true
      }
    },

    mounted () {
      this.getMarkets()
      this.getPayPeriods()
      this.getReadyToSubmitList()
      this.getClaimsCounts()

      $('.column-selector-checkbox').change(function() {
        var checked = $(this).is(":checked")
        var toggleClassName = $(this).data('column-class-name')
        if (checked) {
          $(".result.tab-content").removeClass(toggleClassName)
        } else {
          $(".result.tab-content").addClass(toggleClassName)
        }
      })



    },
    created () {
      // document.title = "Wingz Support | Current Rides";
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .table td {
    vertical-align: middle;
  }
  .table th > div {
    position: relative;
    display: inline;
  }
  .table th > div .arrow-down {
    position: absolute;
    right: -13px;
    top: 40%;
  }
  .table-responsive {
    overflow: hidden;
  }
  .column-settings {
    position: absolute !important;
    right: 25px;
    padding: 5px 0px;
    width: initial;
  }
  .column-settings i {
    padding: 0px 5px;
  }
  .column-settings.mega-dropdown .dropdown-menu {
    width: 300px;
  }

  /* new tab */
  .result.tab-content {
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
  }
  .result.tab-content.hide-col-0 .datatable-col-0,
  .result.tab-content.hide-col-1 .datatable-col-1,
  .result.tab-content.hide-col-2 .datatable-col-2,
  .result.tab-content.hide-col-3 .datatable-col-3,
  .result.tab-content.hide-col-4 .datatable-col-4,
  .result.tab-content.hide-col-5 .datatable-col-5,
  .result.tab-content.hide-col-6 .datatable-col-6,
  .result.tab-content.hide-col-7 .datatable-col-7,
  .result.tab-content.hide-col-8 .datatable-col-8,
  .result.tab-content.hide-col-9 .datatable-col-9,
  .result.tab-content.hide-col-10 .datatable-col-10,
  .result.tab-content.hide-col-11 .datatable-col-11,
  .result.tab-content.hide-col-12 .datatable-col-12,
  .result.tab-content.hide-col-13 .datatable-col-13,
  .result.tab-content.hide-col-14 .datatable-col-14,
  .result.tab-content.hide-col-15 .datatable-col-15,
  .result.tab-content.hide-col-16 .datatable-col-16,
  .result.tab-content.hide-col-17 .datatable-col-17,
  .result.tab-content.hide-col-18 .datatable-col-18,
  .result.tab-content.hide-col-19 .datatable-col-19,
  .result.tab-content.hide-col-20 .datatable-col-20
   {
    display: none;
  }
  .nav-tabs .nav-link{
      border-color: #e9ecef #e9ecef #dee2e6;
      color:darkgray;
  }
  .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
      color: #000000;
      font-weight: bold;
  }
  .nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
      border-color: #e9ecef #e9ecef #dee2e6;
  }
  .tab-options  {
    padding: 20px 5px;
  }
  .tab-options > div {
    display: inline-block;
    /* max-width: 240px; */
    max-width: 400px;
  }
  .submit-button {
    background-color: #E1BC42;
    color: white;
    /* text-transform: uppercase; */
  }
  .table-header-filter select {
    display: inline-block;
    width: initial;
  }
  .error-cell {
    display: table-cell;
    /* border: 1px solid red; */
    color: red;
  }
  .error-cell a {
    color: red;
  }
  .tooltip-effect-3 .tooltip-content {
    background: #cecece;
    text-align: center;
  }
  .tooltip-effect-3 .tooltip-content:after {
    border-top-color: #cecece;
  }
  .table th,
  .table td {
    text-align: left;
  }
  .table th:first-child,
  .table td:first-child {
    text-align: left;
  }
  .mytooltip {
    z-index: initial;
  }
  .transaction-edit-cell .dropdown-menu {
    padding: 20px 10px;
  }
  .transaction-edit-cell .dropdown-menu .warning-msg {
    padding: 10px 0px;
    color: red;
  }

  .transaction-edit-cell .dropdown-menu button {
    width: 100%;
    margin: 10px 0px;
  }

  .event-log-modal .modal-mask {
    height: 100%;
    width: 100%;
  }


</style>
<style>
  .transaction-edit-cell.dropdown .vdatetime-popup {
    max-width: initial !important;
    white-space: normal;
  }
  .event-log-modal .modal-mask .modal-container {
    max-width: 80%;
    max-height: 80%;
    overflow: auto;
  }
  .event-log-modal .modal-mask .modal-header {
    position: relative;
  }
  .event-log-modal .modal-mask .modal-header button {
    position: absolute;
    right: 0px;
    top: 0px;
  }
  .event-log-modal .modal-mask .modal-body {
    overflow-y: scroll;
    max-height: 85%;

        /* max-height: 50%; */
  }

  .tab-content label {
    font-weight: bold;
  }
  .filter-bar {
    margin: 20px 0px;
  }
  .filter-bar .mega-dropdown {
    width: initial;
  }
  .filter-item {
    border-radius: 10px;
    margin: 3px 5px;
    padding: 6px 9px;
    background-color: transparent;
    cursor: pointer;
  }
  .filter-dropdown-toggle {
    font-size: 16px;
    padding: 10px 10px 10px 10px;
  }
  .clear-all-button {
    margin: 10px 20px;
    display: block;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/ClaimsProcessing.vue